"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[233],{

/***/ 76:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Site_url; }
/* harmony export */ });
/* harmony import */ var _utils_environmentVariables__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8252);


var _getEnvironmentVariab = (0,_utils_environmentVariables__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(),
    BACKEND_URL_PROD = _getEnvironmentVariab.BACKEND_URL_PROD,
    ENV = _getEnvironmentVariab.ENV,
    BACKEND_URL_STAGING = _getEnvironmentVariab.BACKEND_URL_STAGING;

var Site_url = ENV === "staging" ? "http://staging.ezylegal.in/" : "https://www.ezylegal.in/"; // export const Site_url = 'http://localhost:3002/';

/***/ }),

/***/ 1501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Breadcrumb; }
});

// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(9097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./styled/Text.tsx
var Text = __webpack_require__(661);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
;// CONCATENATED MODULE: ./components/Breadcrumb/Breadcrumb.styled.tsx

var BreadcrumbWrapper = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
  displayName: "Breadcrumbstyled__BreadcrumbWrapper",
  componentId: "sc-1v3z8q0-0"
})(["& > .breadcrumb{background-color:transparent;padding:0.25rem 0;p{margin-bottom:0;}}& .breadcrumb-item + .breadcrumb-item::before{content:'';background:url(/city-lawyers/icons/arrow_forward.svg) no-repeat center center;width:8px;height:13px;display:inline-block;margin-right:0.5rem;}.breadcrumb-item{display:flex;align-items:center;&.active{color:", ";}}"], function (_ref) {
  var theme = _ref.theme,
      color = _ref.color;
  return theme.textColors['gray'];
});
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ./components/Breadcrumb/index.tsx





var Breadcrumb = function Breadcrumb(_ref) {
  var items = _ref.items;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(BreadcrumbWrapper, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("ol", {
      className: "breadcrumb",
      children: items.map(function (item, i) {
        return item.link ? /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          className: "breadcrumb-item",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: item.link,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
                fontSize: "base",
                children: item.label
              })
            })
          })
        }, i) : /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          className: "breadcrumb-item active",
          "aria-current": "page",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
            inline: true,
            fontSize: "base",
            children: item.label
          })
        }, i);
      })
    })
  });
};

/* harmony default export */ var components_Breadcrumb = (Breadcrumb);

/***/ }),

/***/ 4630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ ButtonStyled; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5505);

var ButtonStyled = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].button.withConfig */ .ZP.button.withConfig({
  displayName: "Buttonstyled__ButtonStyled",
  componentId: "sc-j3lryq-0"
})(["border-radius:", ";background-color:", ";color:", ";font-size:14px;font-weight:", ";text-align:center;padding-top:", ";padding-bottom:", ";", " border-top:", ";border-bottom:", ";border-left:", ";border-right:", ";border-color:", ";width:", ";display:flex;align-items:center;justify-content:center;white-space:nowrap;margin-bottom:", ";margin-left:", ";margin-right:", ";"], function (_ref) {
  var borderRadius = _ref.borderRadius;
  return borderRadius ? borderRadius : "20px";
}, function (_ref2) {
  var backgroundColor = _ref2.backgroundColor;
  return backgroundColor ? backgroundColor : "transparent";
}, function (_ref3) {
  var color = _ref3.color;
  return color ? color : "inherit";
}, function (_ref4) {
  var fontWeight = _ref4.fontWeight;
  return fontWeight ? fontWeight : "600";
}, function (_ref5) {
  var noPadding = _ref5.noPadding;
  return noPadding ? "0" : "7px";
}, function (_ref6) {
  var paddingBottom = _ref6.paddingBottom,
      noPadding = _ref6.noPadding;
  return noPadding ? "0px" : paddingBottom ? paddingBottom : "7px";
}, function (_ref7) {
  var auto = _ref7.auto,
      noPaddingX = _ref7.noPaddingX,
      noPadding = _ref7.noPadding;
  return noPadding ? "padding-left: 0px; padding-right: 0px;" : noPaddingX ? "padding-left: 7px; padding-right: 7px;" : !auto ? "padding-left: 35px; padding-right: 35px;" : "padding-left: 15px; padding-right: 15px;";
}, function (_ref8) {
  var borderTop = _ref8.borderTop;
  return borderTop ? borderTop : "none";
}, function (_ref9) {
  var borderBottom = _ref9.borderBottom;
  return borderBottom ? borderBottom : "none";
}, function (_ref10) {
  var borderLeft = _ref10.borderLeft;
  return borderLeft ? borderLeft : "none";
}, function (_ref11) {
  var borderRight = _ref11.borderRight;
  return borderRight ? borderRight : "none";
}, function (_ref12) {
  var borderColor = _ref12.borderColor;
  return borderColor ? borderColor : "none";
}, function (_ref13) {
  var fullWidth = _ref13.fullWidth;
  return fullWidth ? "100%" : "auto";
}, function (_ref14) {
  var marginBottom = _ref14.marginBottom;
  return marginBottom ? marginBottom : "none";
}, function (_ref15) {
  var marginLeft = _ref15.marginLeft;
  return marginLeft ? marginLeft : "none";
}, function (_ref16) {
  var marginRight = _ref16.marginRight;
  return marginRight ? marginRight : "none";
});

/***/ }),

/***/ 9208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ CardStyled; }
/* harmony export */ });
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6586);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5505);


var CardStyled = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(react_bootstrap__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
  displayName: "Cardstyled__CardStyled",
  componentId: "sc-gu98iy-0"
})(["border-radius:12px;", ";border:none;.card-header{border:none;border-radius:12px 12px 12px 12px;}"], function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor && "background-color: ".concat(backgroundColor);
});

/***/ }),

/***/ 8729:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CityLawyer_FindAllLawyersHeader; }
});

// EXTERNAL MODULE: ./components/CorneredBox/index.tsx + 1 modules
var CorneredBox = __webpack_require__(742);
// EXTERNAL MODULE: ../../node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(1275);
// EXTERNAL MODULE: ../../node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(8264);
// EXTERNAL MODULE: ../../node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(2594);
// EXTERNAL MODULE: ./components/Breadcrumb/index.tsx + 1 modules
var Breadcrumb = __webpack_require__(1501);
// EXTERNAL MODULE: ./styled/Spacer.tsx
var Spacer = __webpack_require__(984);
// EXTERNAL MODULE: ./styled/Text.tsx
var Text = __webpack_require__(661);
// EXTERNAL MODULE: ../../node_modules/lodash/lodash.js
var lodash = __webpack_require__(6635);
// EXTERNAL MODULE: ./components/useResponsiveDevice.ts
var useResponsiveDevice = __webpack_require__(9556);
;// CONCATENATED MODULE: ./utils/decode.ts
var decode = function decode(value) {
  var _document, _div$firstChild;

  var content = value;
  var div = (_document = document) === null || _document === void 0 ? void 0 : _document.createElement('div');
  div.innerHTML = content;
  return div === null || div === void 0 ? void 0 : (_div$firstChild = div.firstChild) === null || _div$firstChild === void 0 ? void 0 : _div$firstChild.nodeValue;
};
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
;// CONCATENATED MODULE: ./components/LegalConsultationProductB.styled.tsx

var ProductBDivImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LegalConsultationProductBstyled__ProductBDivImage",
  componentId: "sc-123hgn3-0"
})(["background-image:url(", ");background-repeat:no-repeat !important;background-position-x:center;background-position-y:center;background-color:", ";position:relative;background-size:cover;overflow:hidden;border-bottom-left-radius:", ";border-bottom-right-radius:", ";"], function (props) {
  return props.img ? "" : "/images/image24.png";
}, function (props) {
  return props.img ? "#fff" : "#18232b";
}, function (props) {
  return props.img ? 0 : "19px";
}, function (props) {
  return props.img ? 0 : "19px";
});
var ProductBLayer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LegalConsultationProductBstyled__ProductBLayer",
  componentId: "sc-123hgn3-1"
})(["background-repeat:no-repeat !important;background-position:center;background-color:#1d89ec;background-size:cover;position:absolute;top:0;bottom:15%;left:0;right:0;opacity:0.7;background:-webkit-radial-gradient( bottom left,rgba(78,71,49,0.6),#18232b );background:-moz-radial-gradient(top rigth,#18232b,#16181c);background:radial-gradient(to top left,#18232b,#16181c);"]);
var ProductBLayerDark = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LegalConsultationProductBstyled__ProductBLayerDark",
  componentId: "sc-123hgn3-2"
})(["background-repeat:no-repeat !important;background-position:center;background-color:#18232b;background-size:cover;position:absolute;top:0;bottom:0;left:0;right:0;opacity:0.4;background:#16181c;background:linear-gradient( 0deg,rgba(22,24,28,1) 2C4054%,rgba(44,64,84,1) 100% );"]);
var ProductBLayerDark2 = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LegalConsultationProductBstyled__ProductBLayerDark2",
  componentId: "sc-123hgn3-3"
})(["background-repeat:no-repeat !important;background-position:center;background-color:#18232b;background-size:cover;position:absolute;top:62%;bottom:0;left:0;right:0;opacity:1;background:#16181c;background:linear-gradient(180deg,rgba(35,41,43,0.2) 0%,#18232b 49.84%);"]);
var ProductBButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "LegalConsultationProductBstyled__ProductBButton",
  componentId: "sc-123hgn3-4"
})(["background-color:#396ae8;color:#ffffff;border:none;display:block;text-align:center;font-size:16px;font-family:Manrope;padding:13px 0;border-radius:50px;width:100%;@media (min-width:600px){width:33.33%;}"]);
var ProductBVideo = styled_components_browser_esm/* default.video.withConfig */.ZP.video.withConfig({
  displayName: "LegalConsultationProductBstyled__ProductBVideo",
  componentId: "sc-123hgn3-5"
})(["position:absolute;top:50%;transform:translateY(-50%);left:0;width:100%;object-fit:cover;@media only screen and (max-width:767px){aspect-ratio:4/5;}@media only screen and (min-width;768px){aspect-ratio:16/5;}"]);
var ProductBVideoFrame = styled_components_browser_esm/* default.iframe.withConfig */.ZP.iframe.withConfig({
  displayName: "LegalConsultationProductBstyled__ProductBVideoFrame",
  componentId: "sc-123hgn3-6"
})(["position:absolute;top:50%;transform:translateY(-50%) translateX(-50%);left:50%;object-fit:cover;"]);
// EXTERNAL MODULE: ./api/config.js
var config = __webpack_require__(76);
// EXTERNAL MODULE: ./components/HeadingText1.tsx
var HeadingText1 = __webpack_require__(2792);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ./components/CityLawyer/FindAllLawyersHeader.tsx














var FindAllLawyersHeader = function FindAllLawyersHeader(_ref) {
  var _product$product_addi, _product$product_addi2;

  var product = _ref.product,
      city = _ref.city,
      concernedArea = _ref.concernedArea;

  var _useResponsiveDevice = (0,useResponsiveDevice/* default */.Z)(),
      isMobile = _useResponsiveDevice.isMobile;

  var breadcrumbItems = [{
    label: "Home",
    link: "/"
  }, {
    label: "Find all lawyers in cities",
    link: null
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CorneredBox/* default */.Z, {
    marginTop: "-25px",
    paddingTop: "30px",
    zIndex: 16,
    position: "relative",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ProductBDivImage, {
      className: "row ml-0 mr-0",
      style: {
        marginTop: -30,
        paddingBottom: 50
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ProductBVideo, {
          autoPlay: true,
          muted: true,
          loop: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("source", {
            src: "/city-lawyers/videos/legal-consultation.mp4",
            type: "video/mp4"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ProductBLayerDark, {
          className: "col-12 m-0 p-0"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ProductBLayer, {
          className: "col-12 m-0 p-0"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ProductBLayerDark2, {
          className: "col-12 m-0 p-0"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Container/* default */.Z, {
        className: "pt-1",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Breadcrumb/* default */.Z, {
          items: breadcrumbItems
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Row/* default */.Z, {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Col/* default */.Z, {
            xs: 12,
            md: 7,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HeadingText1/* default */.Z, {
              fontSize: "xxxl",
              weight: "bold",
              color: "white",
              fontFamily: "montserrat",
              children: concernedArea !== '' && city !== '' ? "Consult ".concat(concernedArea, " Lawyers in ").concat(city) : concernedArea == '' && city !== '' ? "Connect with Expert Lawyers in ".concat(city !== '' ? city : 'your city') : "Connect with Expert Lawyers in your city"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
              direction: "vertical",
              size: 10
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "d-flex justify-content-lg-start ".concat(isMobile ? "flex-column" : "align-items-center"),
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "d-flex align-items-center",
                "data-clarity-unmask": "True",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  "data-src": "https://i.ibb.co/fNhX2XC/wifi-tethering-24pxonline.png",
                  alt: "copy",
                  width: 20,
                  className: "lozad mr-2"
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Text/* default */.Z, {
                  fontSize: "md",
                  weight: "bold",
                  color: "white",
                  style: {
                    margin: "unset"
                  },
                  "data-clarity-unmask": "True",
                  children: [(0,lodash.random)(90, 120), " Lawyers online"]
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
                size: isMobile ? 10 : 20,
                direction: isMobile ? "vertical" : "horizontal"
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "d-flex align-items-center",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  "data-src": "https://i.ibb.co/g9ZB0Rv/call-24pxcalls.png",
                  alt: "stars",
                  width: 20,
                  className: "lozad mr-2"
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Text/* default */.Z, {
                  fontSize: "md",
                  weight: "bold",
                  color: "white",
                  style: {
                    margin: "unset"
                  },
                  children: [(0,lodash.random)(40, 80), " Calls currently going on"]
                })]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
              direction: "vertical",
              size: 14
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
              as: "div",
              dangerouslySetInnerHTML: {
                __html: product.description || ""
              },
              fontSize: "mdl",
              weight: "normal",
              color: "white"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
              direction: "vertical",
              size: 10
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(ProductBButton, {
              onClick: function onClick() {
                var newPath = "".concat(config/* Site_url */.Z, "legal-consultation");
                window.location.href = newPath; // router.push("/legal-consultation");
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
                href: "".concat(config/* Site_url */.Z, "legal-consultation?utm_source=city-page&utm_medium=city-page-header-cta-button&utm_campaign=").concat(product.slug),
                style: {
                  color: "white"
                },
                children: ["Consult Lawyer", " ", /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  width: 24,
                  src: "/city-lawyers/icons/arrow-forward.svg",
                  alt: "arrow" // className="lazyload ml-2"
                  ,
                  className: "lozad ml-2",
                  "data-src": "/icons/arrow-forward.svg"
                })]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("hr", {
              style: {
                marginTop: "2.5rem",
                marginBottom: "2.5rem",
                border: 0,
                borderTop: "1px solid rgba(255, 255, 255, 0.1)"
              }
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              style: {
                display: "flex",
                justifyContent: "space-around",
                gap: "1.5rem"
              },
              children: (_product$product_addi = product.product_addition) === null || _product$product_addi === void 0 ? void 0 : (_product$product_addi2 = _product$product_addi.productCharacteristics) === null || _product$product_addi2 === void 0 ? void 0 : _product$product_addi2.map(function (productCharacteristic, index) {
                var _productCharacteristi;

                return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "d-md-flex align-items-center ".concat(isMobile ? "mb-3 text-center" : ""),
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                    "data-src": (_productCharacteristi = productCharacteristic.icon) === null || _productCharacteristi === void 0 ? void 0 : _productCharacteristi.sourceUrl // alt={productCharacteristic.icon?.title}
                    ,
                    alt: productCharacteristic === null || productCharacteristic === void 0 ? void 0 : productCharacteristic.alttext,
                    width: 40,
                    style: {
                      width: 40,
                      height: 40,
                      objectFit: "contain",
                      marginRight: ".625rem",
                      filter: "invert(100%) sepia(100%) saturate(0%) hue-rotate(288deg) brightness(102%) contrast(102%)"
                    },
                    className: "lozad"
                  }), isMobile && /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
                    direction: "vertical",
                    size: 10
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
                    inline: true,
                    color: "white",
                    className: "mb-0",
                    fontSize: isMobile ? "sm" : "base",
                    weight: "semibold",
                    children:  true ? decode(productCharacteristic.label) : 0
                  })]
                }, index);
              })
            })]
          })
        })]
      })]
    })
  });
};

/* harmony default export */ var CityLawyer_FindAllLawyersHeader = (FindAllLawyersHeader);

/***/ }),

/***/ 6931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CityLawyer_LeadCityLawyerForm; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(8526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../node_modules/react-bootstrap/esm/Form.js + 13 modules
var Form = __webpack_require__(7137);
// EXTERNAL MODULE: ../../node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(2594);
// EXTERNAL MODULE: ../../node_modules/react-bootstrap/esm/Spinner.js
var Spinner = __webpack_require__(4325);
// EXTERNAL MODULE: ./styled/Text.tsx
var Text = __webpack_require__(661);
// EXTERNAL MODULE: ../../node_modules/react-flags-select/build/index.esm.js
var index_esm = __webpack_require__(7832);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./utils/selectCountry.ts
var selectCountry = __webpack_require__(3152);
;// CONCATENATED MODULE: ./json-data/state.json
var state_namespaceObject = JSON.parse('[{"name":"Andaman and Nicobar Islands","state_code":"AN"},{"name":"Andhra Pradesh","state_code":"AP"},{"name":"Arunachal Pradesh","state_code":"AR"},{"name":"Assam","state_code":"AS"},{"name":"Bihar","state_code":"BR"},{"name":"Chandigarh","state_code":"CH"},{"name":"Chhattisgarh","state_code":"CT"},{"name":"Dadra and Nagar Haveli","state_code":"DN"},{"name":"Daman and Diu","state_code":"DD"},{"name":"Delhi","state_code":"DL"},{"name":"Goa","state_code":"GA"},{"name":"Gujarat","state_code":"GJ"},{"name":"Haryana","state_code":"HR"},{"name":"Himachal Pradesh","state_code":"HP"},{"name":"Jammu and Kashmir","state_code":"JK"},{"name":"Jharkhand","state_code":"JH"},{"name":"Karnataka","state_code":"KA"},{"name":"Kerala","state_code":"KL"},{"name":"Ladakh","state_code":"LA"},{"name":"Lakshadweep","state_code":"LD"},{"name":"Madhya Pradesh","state_code":"MP"},{"name":"Maharashtra","state_code":"MH"},{"name":"Manipur","state_code":"MN"},{"name":"Meghalaya","state_code":"ML"},{"name":"Mizoram","state_code":"MZ"},{"name":"Nagaland","state_code":"NL"},{"name":"Odisha","state_code":"OR"},{"name":"Puducherry","state_code":"PY"},{"name":"Punjab","state_code":"PB"},{"name":"Rajasthan","state_code":"RJ"},{"name":"Sikkim","state_code":"SK"},{"name":"Tamil Nadu","state_code":"TN"},{"name":"Telangana","state_code":"TG"},{"name":"Tripura","state_code":"TR"},{"name":"Uttar Pradesh","state_code":"UP"},{"name":"Uttarakhand","state_code":"UT"},{"name":"West Bengal","state_code":"WB"}]');
// EXTERNAL MODULE: ../../node_modules/yup/es/index.js + 26 modules
var es = __webpack_require__(5413);
// EXTERNAL MODULE: ../../node_modules/yup-phone/dist/yup-phone.umd.js
var yup_phone_umd = __webpack_require__(2702);
// EXTERNAL MODULE: ../../node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(6812);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var dist_index_esm = __webpack_require__(3955);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 18 modules
var react_redux_es = __webpack_require__(2772);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ./components/useResponsiveDevice.ts
var useResponsiveDevice = __webpack_require__(9556);
// EXTERNAL MODULE: ./utils/getLocation.ts + 1 modules
var getLocation = __webpack_require__(1272);
// EXTERNAL MODULE: ./utils/deviceInfoService.ts
var deviceInfoService = __webpack_require__(6902);
// EXTERNAL MODULE: ../../node_modules/react-bootstrap-typeahead/es/index.js + 54 modules
var react_bootstrap_typeahead_es = __webpack_require__(7959);
;// CONCATENATED MODULE: ./constants/cities.ts
var CITIES = ["Mumbai", "Delhi", "Bangalore", "Hyderabad", "Ahmedabad", "Chennai", "Kolkata", "Surat", "Pune", "Jaipur", "Lucknow", "Kanpur", "Nagpur", "Indore", "Thane", "Bhopal", "Visakhapatnam", "Pimpri-Chinchwad", "Patna", "Vadodara", "Ghaziabad", "Ludhiana", "Agra", "Nashik", "Ranchi", "Faridabad", "Meerut", "Rajkot", "Kalyan-Dombivli", "Vasai-Virar", "Varanasi", "Srinagar", "Aurangabad", "Dhanbad", "Gurgaon", "Amritsar", "Navi Mumbai", "Allahabad", "Howrah", "Gwalior", "Jabalpur", "Coimbatore", "Vijayawada", "Jodhpur", "Madurai", "Raipur", "Kota", "Salem", "Chandigarh", "Guwahati", "Solapur", "Hubli–Dharwad", "Mysore", "Tiruchirappalli", "Bareilly", "Aligarh", "Tiruppur", "Moradabad", "Jalandhar", "Bhubaneswar", "Warangal", "Mira-Bhayandar", "Jalgaon", "Guntur", "Thiruvananthapuram", "Bhiwandi", "Saharanpur", "Gorakhpur", "Bikaner", "Amravati", "Noida", "Jamshedpur", "Bhilai", "Cuttack", "Firozabad", "Kochi", "Nellore", "Bhavnagar", "Dehradun", "Durgapur", "Asansol", "Rourkela", "Nanded", "Kolhapur", "Ajmer", "Akola", "Gulbarga", "Jamnagar", "Ujjain", "Loni", "Siliguri", "Jhansi", "Ulhasnagar", "Jammu"];
// EXTERNAL MODULE: ./redux/store.ts + 22 modules
var store = __webpack_require__(7370);
// EXTERNAL MODULE: ./api/backendApi.ts
var backendApi = __webpack_require__(5484);
// EXTERNAL MODULE: ./redux/loggedInUser/loggedInUser.actions.ts + 1 modules
var loggedInUser_actions = __webpack_require__(6486);
;// CONCATENATED MODULE: ./constants/queries/leads.ts
var CREATE_LEAD_QUERY = "\n    mutation createLead(\n        $concerned_area: String!\n        $concerned_area_category: String!\n        $country: String!\n        $country_code: Int!\n        $device: String\n        $device_type: String\n        $email: String!\n        $mobile: Float!\n        $name: String!\n        $page_url: String\n        $requirement: String!\n        $source: String\n        $user_agent: String\n        $user_ip_address: String\n        $user_type: UserType\n        $placement : String\n        $utm : [UtmInput!],\n        $city: String,\n        $state: String\n    )\n    {\n        createLead(createLeadInput: {\n            concerned_area: $concerned_area,\n            concerned_area_category: $concerned_area_category,\n            country: $country,\n            country_code: $country_code,\n            device: $device,\n            device_type: $device_type,\n            email: $email,\n            mobile: $mobile,\n            name: $name,\n            city: $city,\n            state: $state,\n            page_url: $page_url,\n            requirement: $requirement,\n            source: $source\n            user_agent: $user_agent,\n            user_ip_address: $user_ip_address,\n            user_type: $user_type,\n            placement : $placement,\n            utm : $utm,\n        }){\n            _id\n        }\n    }\n";
var CREATE_LEAD_POP_UP_QUERY = "\n    mutation createLead(\n        $concerned_area: String\n        $concerned_area_category: String\n        $country: String!\n        $country_code: Int!\n        $device: String\n        $device_type: String\n        $email: String!\n        $mobile: Float!\n        $name: String!\n        $page_url: String\n        $requirement: String!\n        $source: String\n        $user_agent: String\n        $user_ip_address: String\n        $user_type: UserType\n        $placement : String\n        $utm : [UtmInput!],\n        $city: String,\n        $state: String\n    )\n    {\n        createLead(createLeadInput: {\n            concerned_area: $concerned_area,\n            concerned_area_category: $concerned_area_category,\n            country: $country,\n            country_code: $country_code,\n            device: $device,\n            device_type: $device_type,\n            email: $email,\n            mobile: $mobile,\n            name: $name,\n            city: $city,\n            state: $state,\n            page_url: $page_url,\n            requirement: $requirement,\n            source: $source\n            user_agent: $user_agent,\n            user_ip_address: $user_ip_address,\n            user_type: $user_type,\n            placement : $placement,\n            utm : $utm,\n        }){\n            _id\n        }\n    }\n";
// EXTERNAL MODULE: ./utils/toasts.ts
var toasts = __webpack_require__(3200);
// EXTERNAL MODULE: ./api/config.js
var config = __webpack_require__(76);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ./components/CityLawyer/LeadCityLawyerForm.tsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




























var LeadCityLawyerForm = function LeadCityLawyerForm() {
  var _errors$fullName, _errors$email, _errors$state;

  var geolocation = (0,react_redux_es/* useSelector */.v9)(function (store) {
    return store.location.geolocation;
  });

  var _useState = (0,react.useState)(geolocation == 'in' ? 'IN' : 'US'),
      country = _useState[0],
      setCountry = _useState[1];

  var _useState2 = (0,react.useState)(geolocation == 'in' ? '91' : '1'),
      code = _useState2[0],
      setCode = _useState2[1];

  var _useState3 = (0,react.useState)(""),
      city = _useState3[0],
      setCity = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      cityError = _useState5[0],
      setCityError = _useState5[1];

  var dispatch = (0,react_redux_es/* useDispatch */.I0)();

  var _useState6 = (0,react.useState)({}),
      deviceDetails = _useState6[0],
      setDeviceDetails = _useState6[1];

  var setCountryCode = function setCountryCode(code) {
    var country = (0,selectCountry/* default */.Z)(code);
    setCode(country);
    setCountry(code);
  };

  var router = (0,next_router.useRouter)();

  var _useResponsiveDevice = (0,useResponsiveDevice/* default */.Z)(),
      isMobile = _useResponsiveDevice.isMobile;

  var LeadCityLawyerFormSchema = country == "IN" ? es.object().shape({
    fullName: es.string().required('Name is required'),
    email: es.string().email().required('Email is required'),
    // requirement: yup.string().required('Requirement Code is required'),
    mobile: es.string().phone().test('len', function (val, _ref) {
      var createError = _ref.createError,
          path = _ref.path;
      return (val === null || val === void 0 ? void 0 : val.length) === 10 ? true : createError({
        path: path,
        message: 'Phone number should be valid and 10 digits long'
      });
    }).required(),
    state: es.string().required('State is required')
  }) : es.object().shape({
    fullName: es.string(),
    email: es.string().email().required('Email is required'),
    // requirement: yup.string().required('Requirement Code is required'),
    mobile: es.string().required()
  });
  (0,react.useEffect)(function () {
    LeadCityLawyerFormSchema = country == "IN" ? es.object().shape({
      fullName: es.string(),
      email: es.string().email().required('Email is required'),
      // requirement: yup.string().required('Requirement Code is required'),
      mobile: es.string().phone().test('len', function (val, _ref2) {
        var createError = _ref2.createError,
            path = _ref2.path;
        return (val === null || val === void 0 ? void 0 : val.length) === 10 ? true : createError({
          path: path,
          message: 'Phone number should be valid and 10 digits long'
        });
      }).required()
    }) : es.object().shape({
      fullName: es.string(),
      email: es.string().email().required('Email is required'),
      // requirement: yup.string().required('Requirement Code is required'),
      mobile: es.string().required()
    });
  }, [country]); // useEffect(()=>{
  //   let res = props?.title.split(" ").join("-").toLowerCase()+'-form';
  //   setPoaClass(res);
  // },[props.title]);

  (0,react.useEffect)(function () {
    var getDetails = /*#__PURE__*/function () {
      var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var _router$query, _router$query2;

        var placement, ip, result;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                placement = router !== null && router !== void 0 && (_router$query = router.query) !== null && _router$query !== void 0 && _router$query.placement ? router === null || router === void 0 ? void 0 : (_router$query2 = router.query) === null || _router$query2 === void 0 ? void 0 : _router$query2.placement : 'undefined';
                _context.next = 3;
                return (0,getLocation/* getLocation */.k)();

              case 3:
                ip = _context.sent;
                // const device = await getDeviceDetails();
                result = {
                  device: '',
                  device_type: isMobile ? 'Mobile' : 'Desktop',
                  ip_address: ip ? ip : '',
                  path: (0,deviceInfoService/* getPageURL */.VQ)(),
                  userAgent: (0,deviceInfoService/* getUserAgent */.ij)(),
                  placement: placement
                };
                setDeviceDetails(_objectSpread({}, result));

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getDetails() {
        return _ref3.apply(this, arguments);
      };
    }();

    getDetails();
  }, []);

  var _useForm = (0,dist_index_esm/* useForm */.cI)({
    resolver: (0,yup/* yupResolver */.X)(LeadCityLawyerFormSchema),
    defaultValues: {
      fullName: '',
      email: '',
      mobile: '',
      requirement: '',
      state: '',
      city: ''
    }
  }),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      reset = _useForm.reset,
      errors = _useForm.formState.errors,
      watch = _useForm.watch;

  var resetAllValue = function resetAllValue() {
    reset({
      fullName: '',
      email: '',
      mobile: '',
      requirement: '',
      state: '',
      city: ''
    });
    setCity("");
  };

  var onSubmit = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(data) {
      var _store$getState;

      var trackingData, _deviceDetails$ip_add, _deviceDetails$ip_add2;

      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              trackingData = (_store$getState = store/* store.getState */.h.getState()) === null || _store$getState === void 0 ? void 0 : _store$getState.tracking;

              if (!(city == '' || city == undefined)) {
                _context2.next = 5;
                break;
              }

              setCityError(true);
              _context2.next = 20;
              break;

            case 5:
              _context2.prev = 5;
              setLoading(true);
              _context2.next = 9;
              return backendApi/* default.post */.Z.post('/', {
                query: CREATE_LEAD_POP_UP_QUERY,
                variables: {
                  country: geolocation,
                  country_code: parseInt(code),
                  mobile: parseFloat(data.mobile),
                  email: data.email,
                  name: data.fullName,
                  requirement: data.requirement,
                  user_type: 'INDIVIDUAL',
                  user_ip_address: deviceDetails === null || deviceDetails === void 0 ? void 0 : (_deviceDetails$ip_add = deviceDetails.ip_address) === null || _deviceDetails$ip_add === void 0 ? void 0 : _deviceDetails$ip_add.query,
                  user_agent: deviceDetails === null || deviceDetails === void 0 ? void 0 : deviceDetails.userAgent,
                  page_url: deviceDetails === null || deviceDetails === void 0 ? void 0 : deviceDetails.path,
                  device_type: deviceDetails === null || deviceDetails === void 0 ? void 0 : deviceDetails.device_type,
                  concerned_area: null,
                  // source: 'POA_LEAD',
                  source: 'City Lead',
                  city: city,
                  state: data.state,
                  concerned_area_category: null,
                  placement: deviceDetails === null || deviceDetails === void 0 ? void 0 : deviceDetails.placement,
                  utm: trackingData.UTM
                }
              });

            case 9:
              _context2.t0 = dispatch;
              _context2.next = 12;
              return (0,loggedInUser_actions/* signUp */.y1)({
                email: data.email,
                name: data.fullName && data.fullName !== '' ? data.fullName : 'User',
                mobile: parseFloat(data.mobile),
                countryCode: parseInt(code),
                type: 'INDIVIDUAL',
                user_ip_address: deviceDetails === null || deviceDetails === void 0 ? void 0 : (_deviceDetails$ip_add2 = deviceDetails.ip_address) === null || _deviceDetails$ip_add2 === void 0 ? void 0 : _deviceDetails$ip_add2.query,
                user_agent: deviceDetails === null || deviceDetails === void 0 ? void 0 : deviceDetails.userAgent,
                page_url: deviceDetails === null || deviceDetails === void 0 ? void 0 : deviceDetails.path,
                device_type: deviceDetails === null || deviceDetails === void 0 ? void 0 : deviceDetails.device_type,
                // source: 'POA_LEAD',
                source: 'City Lead',
                city: city,
                state: data.state,
                concerned_area: null,
                concerned_area_category: null,
                utm: trackingData.UTM
              }, function () {
                (0,toasts/* successToast */.Qm)('Thank you for your interest. Our team will get back to you soon.');
                var newPath = "".concat(config/* Site_url */.Z, "legal-consultation");
                window.location.href = newPath;
                setLoading(false);
                resetAllValue(); // setPoaClass('popup-lead-form-submitted');
                // let res = props?.title.split(" ").join("-").toLowerCase()+'-form-submitted';
                // setPoaClass(res);
                // if (props.onHide) {
                //   props.onHide();
                // }
              }, true);

            case 12:
              _context2.t1 = _context2.sent;
              (0, _context2.t0)(_context2.t1);
              _context2.next = 20;
              break;

            case 16:
              _context2.prev = 16;
              _context2.t2 = _context2["catch"](5);
              (0,toasts/* errorToast */.Jc)(_context2.t2.message);
              setLoading(false);

            case 20:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[5, 16]]);
    }));

    return function onSubmit(_x) {
      return _ref4.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Form/* default */.Z, {
    onSubmit: handleSubmit(onSubmit),
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", _objectSpread(_objectSpread({}, register('fullName')), {}, {
        className: "form-control",
        "data-clarity-unmask": "True",
        placeholder: "Enter your Full name"
      })), errors.fullName && /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
        color: "red",
        fontSize: "xs",
        children: (_errors$fullName = errors.fullName) === null || _errors$fullName === void 0 ? void 0 : _errors$fullName.message
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", _objectSpread(_objectSpread({}, register('email')), {}, {
        className: "form-control",
        "data-clarity-unmask": "True",
        placeholder: "Enter your Email Address"
      })), errors.email && /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
        color: "red",
        fontSize: "xs",
        children: (_errors$email = errors.email) === null || _errors$email === void 0 ? void 0 : _errors$email.message
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Form/* default.Group */.Z.Group, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Form/* default.Row */.Z.Row, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
          xs: "auto",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* default */.ZP, {
            selected: country,
            onSelect: function onSelect(code) {
              setCountryCode(code);
            },
            countries: ["IN", "US", "GB", "CA", "ZA", "AU", "SG", "MY", "AE", "SA"],
            optionsSize: 14,
            selectedSize: 12,
            customLabels: {
              IN: "+91",
              US: "+1",
              GB: "+44",
              CA: "+1",
              ZA: "+27",
              AU: "+61",
              SG: "+65",
              MY: "+60",
              AE: "+971",
              SA: "+966"
            }
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Col/* default */.Z, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", _objectSpread(_objectSpread({}, register('mobile')), {}, {
            className: "form-control",
            "data-clarity-unmask": "True",
            placeholder: "Mobile No."
          })), errors.mobile && /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
            color: "red",
            fontSize: "xs",
            children: "Invalid mobile number"
          }) // : (
          //   <Text fontSize="xs">Enter a valid phone number</Text>
          // )
          ]
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Form/* default.Group */.Z.Group, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
        as: "textarea",
        placeholder: "Describe your requirement",
        rows: 3
      })
    }), geolocation == 'in' ? /*#__PURE__*/(0,jsx_runtime.jsx)(Form/* default.Group */.Z.Group, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Form/* default.Row */.Z.Row, {
        style: {
          display: isMobile ? 'block' : "flex"
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Col/* default */.Z, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(react_bootstrap_typeahead_es/* Typeahead */.pY, _objectSpread(_objectSpread({
            id: "basic-typeahead-single"
          }, register('city')), {}, {
            placeholder: "Enter your City",
            onInputChange: function onInputChange(e) {
              if ((e === null || e === void 0 ? void 0 : e.length) > 0) {
                setCityError(false);
                setCity(e);
              } else {
                setCity('');
              }
            },
            onChange: function onChange(selected) {
              if (selected.length >= 1) {
                setCityError(false);
                setCity(selected[0].toString());
              } else {
                setCity('');
              }
            } // isInvalid={city == "" ? true : false}
            ,
            options: CITIES,
            defaultInputValue: city
          })), cityError && /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
            color: "red",
            fontSize: "xs",
            children: "City is required"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Col/* default */.Z, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("select", _objectSpread(_objectSpread({
            className: "form-control"
          }, register('state')), {}, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("option", {
              value: "",
              children: "Select a state"
            }, "default-state"), state_namespaceObject.map(function (stateData) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                value: stateData.state_code,
                children: stateData.name
              }, stateData.state_code);
            })]
          })), errors.state && /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
            color: "red",
            fontSize: "xs",
            children: (_errors$state = errors.state) === null || _errors$state === void 0 ? void 0 : _errors$state.message
          })]
        })]
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Form/* default.Group */.Z.Group, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Form/* default.Row */.Z.Row, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
            className: "form-control",
            placeholder: "Your City",
            onChange: function onChange(e) {
              setCityError(false);
              setCity(e.target.value);
            },
            value: city
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("input", _objectSpread({
            className: "form-control",
            placeholder: "Your State"
          }, register('state')))
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "d-flex justify-content-center align-items-center",
      children: loading ? /*#__PURE__*/(0,jsx_runtime.jsx)(Spinner/* default */.Z, {
        animation: "border",
        color: "#396AE8",
        style: {
          color: '#396AE8'
        }
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        className: "blog_send_enquiry_btn blink_me",
        children: "Request a Call Back"
      }) // <ButtonStyled color="#FFFFFF" backgroundColor="#396AE8" type="submit" size="md">
      //   Ask Lawyer
      // </ButtonStyled>

    })]
  });
};

/* harmony default export */ var CityLawyer_LeadCityLawyerForm = (LeadCityLawyerForm);

/***/ }),

/***/ 742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_CorneredBox; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
;// CONCATENATED MODULE: ./components/CorneredBox/CorneredBox.styled.tsx

var CorneredBoxWrapper = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "CorneredBoxstyled__CorneredBoxWrapper",
  componentId: "sc-1wwyuup-0"
})(["background-color:", ";padding-bottom:2px;border-radius:0 0 18px 18px;@media (max-width:768px){&.mobile-bg-white{background:white !important;}}"], function (_ref) {
  var theme = _ref.theme,
      backgroundColor = _ref.backgroundColor;
  return backgroundColor === '#F4F5F7' ? '#F4F5F7' : backgroundColor === '#42526E' ? '#42526E' : theme.backgroundColors[backgroundColor || 'white'];
});
var CorneredBoxInner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CorneredBoxstyled__CorneredBoxInner",
  componentId: "sc-1wwyuup-1"
})(["background-color:", ";border-radius:12px 12px 12px 12px;box-shadow:0px 1px 0px rgba(0,0,0,0.25);@media (max-width:768px){.mobile-bg-white > &{box-shadow:none !important;}}", " ", " ", ""], function (_ref2) {
  var theme = _ref2.theme,
      backgroundColor = _ref2.backgroundColor;
  return theme.backgroundColors[backgroundColor || 'white'];
}, function (props) {
  return props.paddingTop && (0,styled_components_browser_esm/* css */.iv)(["padding-top:", ";"], props.paddingTop);
}, function (props) {
  return props.paddingBottom && (0,styled_components_browser_esm/* css */.iv)(["padding-bottom:", ";"], props.paddingBottom);
}, function (props) {
  return props.position && (0,styled_components_browser_esm/* css */.iv)(["position:", ";"], props.position);
});
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ./components/CorneredBox/index.tsx




var CorneredBox = function CorneredBox(_ref) {
  var id = _ref.id,
      children = _ref.children,
      bgColorBack = _ref.bgColorBack,
      paddingTop = _ref.paddingTop,
      marginTop = _ref.marginTop,
      paddingBottom = _ref.paddingBottom,
      bgColor = _ref.bgColor,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      _ref$innerClassName = _ref.innerClassName,
      innerClassName = _ref$innerClassName === void 0 ? "" : _ref$innerClassName,
      _ref$mobileBg = _ref.mobileBg,
      mobileBg = _ref$mobileBg === void 0 ? "" : _ref$mobileBg,
      zIndex = _ref.zIndex,
      position = _ref.position,
      ref = _ref.ref;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CorneredBoxWrapper, {
    backgroundColor: bgColorBack,
    className: className,
    id: id,
    ref: ref,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(CorneredBoxInner, {
      id: "cornered_box",
      backgroundColor: bgColor,
      position: position,
      className: innerClassName,
      style: {
        zIndex: zIndex ? zIndex : "unset",
        marginTop: marginTop ? marginTop : "0px",
        paddingBottom: paddingBottom ? paddingBottom : "0px",
        paddingTop: paddingTop ? paddingTop : "0px"
      },
      children: children
    })
  });
};

/* harmony default export */ var components_CorneredBox = (CorneredBox);

/***/ }),

/***/ 2792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5505);

var HeadingText1 = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].h1.withConfig */ .ZP.h1.withConfig({
  displayName: "HeadingText1",
  componentId: "sc-1szidjh-0"
})(["color:", ";font-size:", ";font-family:", ";font-weight:", ";line-height:1.5em;margin-bottom:8px;", " ", " ", " ", ""], function (_ref) {
  var theme = _ref.theme,
      color = _ref.color;
  return theme.textColors[color || '#091E42'];
}, function (_ref2) {
  var theme = _ref2.theme,
      fontSize = _ref2.fontSize;
  return theme.fontSize[fontSize || 'md'];
}, function (_ref3) {
  var theme = _ref3.theme,
      fontFamily = _ref3.fontFamily;
  return theme.fontFamily[fontFamily || 'manrope'];
}, function (_ref4) {
  var theme = _ref4.theme,
      weight = _ref4.weight;
  return theme.fontWeight[weight || 'normal'];
}, function (props) {
  return props.inline && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["display:inline-block;"]);
}, function (props) {
  return props.block && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["display:block;"]);
}, function (props) {
  return props.center && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["text-align:center;"]);
}, function (props) {
  return props.justify && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["text-align:justify;"]);
});
/* harmony default export */ __webpack_exports__["Z"] = (HeadingText1);

/***/ }),

/***/ 4050:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_MainLayout; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(8526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(9097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
;// CONCATENATED MODULE: ./components/Footer/Footer.styled.tsx

var FooterMenu = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "Footerstyled__FooterMenu",
  componentId: "sc-190dn9-0"
})(["padding:0;list-style:none;display:flex;gap:10px;"]);
var Footer2Menu = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "Footerstyled__Footer2Menu",
  componentId: "sc-190dn9-1"
})(["padding:0;list-style:none;& > li{margin-bottom:10px;}"]);
var FooterContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Footerstyled__FooterContainer",
  componentId: "sc-190dn9-2"
})(["position:relative;height:unset;background:white;border-radius:20px;padding:8px 16px 8px 16px;box-sizing:border-box;cursor:pointer;display:flex;-webkit-box-pack:justify;justify-content:space-between;-webkit-box-align:center;align-items:center;border-bottom:5px solid #396AE8;box-shadow:rgb(80 80 80 / 10%) 0px 0px 24px;"]);
var FooterContainerMessage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Footerstyled__FooterContainerMessage",
  componentId: "sc-190dn9-3"
})(["font-size:16px;margin-right:10px;width:100%;"]);
var FooterContainerIconFrame = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Footerstyled__FooterContainerIconFrame",
  componentId: "sc-190dn9-4"
})(["border-radius:20px;padding-top:10px;padding-bottom:10px;padding-left:inherit;display:flex;align-self:flex-end;"]);
var MessageContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Footerstyled__MessageContent",
  componentId: "sc-190dn9-5"
})(["cursor:pointer;color:#303030;word-break:break-word;font-size:15px;line-height:20px;max-height:60px;max-width:240px;padding-right:2px;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden;white-space:pre-wrap;"]);
var FooterTop = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "Footerstyled__FooterTop",
  componentId: "sc-190dn9-6"
})(["background-color:", ";padding:40px 0;background-image:url('/city-lawyers/images/footer-pattern.png');background-repeat:no-repeat;background-position:right bottom;margin-top:-20px;"], function (_ref) {
  var theme = _ref.theme;
  return theme.backgroundColors['secondary'];
});
var Footer_styled_Footer = styled_components_browser_esm/* default.footer.withConfig */.ZP.footer.withConfig({
  displayName: "Footerstyled__Footer",
  componentId: "sc-190dn9-7"
})(["background-color:", ";padding:40px 0;margin-top:-15px;a{color:#4c95d3;}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.backgroundColors['darkBlue'];
});
var FloatingGreeting = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Footerstyled__FloatingGreeting",
  componentId: "sc-190dn9-8"
})(["position:fixed;right:0.75rem;bottom:4.75rem;z-index:70;max-width:215px;width:215px;"]);
var FloatingButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Footerstyled__FloatingButton",
  componentId: "sc-190dn9-9"
})(["position:fixed;right:0.75rem;bottom:4.75rem;padding:0.5rem;box-shadow:1px 1px 4px 4px #ccc;background-color:", ";border-radius:50%;height:3rem;width:3rem;z-index:9999;"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.backgroundColors['white'];
});
// EXTERNAL MODULE: ./styled/Text.tsx
var Text = __webpack_require__(661);
// EXTERNAL MODULE: ./styled/Spacer.tsx
var Spacer = __webpack_require__(984);
;// CONCATENATED MODULE: ./styled/Button.tsx

var Button = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "Button",
  componentId: "sc-15vzyk7-0"
})(["background-color:", ";color:", ";border:none;display:inline-block;text-align:center;&[disabled]{background-color:", ";cursor:not-allowed;&:hover{background-color:", ";pointer-events:none;}}", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " &:hover{color:", ";background-color:", ";", "}& > img{vertical-align:middle;margin-left:8px;}"], function (_ref) {
  var theme = _ref.theme,
      backgroundColor = _ref.backgroundColor;
  return theme.backgroundColors[backgroundColor || 'primary'];
}, function (_ref2) {
  var theme = _ref2.theme,
      color = _ref2.color;
  return theme.textColors[color || 'white'];
}, function (props) {
  return props.theme.backgroundColors.darkGray;
}, function (props) {
  return props.theme.backgroundColors.darkGray;
}, function (props) {
  return props.size === 'xs' && (0,styled_components_browser_esm/* css */.iv)(["font-size:", ";padding:4px 14px;"], function (_ref3) {
    var theme = _ref3.theme;
    return theme.fontSize['xs'];
  });
}, function (props) {
  return props.variant === 'default' && (0,styled_components_browser_esm/* css */.iv)(["font-family:", ";height:60px;font-weight:600;padding:4px 14px;"], function (_ref4) {
    var theme = _ref4.theme;
    return theme.fontFamily['manrope'];
  });
}, function (props) {
  return props.size === 'sm' && (0,styled_components_browser_esm/* css */.iv)(["font-size:", ";padding:6px 24px;"], function (_ref5) {
    var theme = _ref5.theme;
    return theme.fontSize['sm'];
  });
}, function (props) {
  return props.size === 'md' && (0,styled_components_browser_esm/* css */.iv)(["font-size:", ";padding:10px 32px;"], function (_ref6) {
    var theme = _ref6.theme;
    return theme.fontSize['md'];
  });
}, function (props) {
  return props.size === 'lg' && (0,styled_components_browser_esm/* css */.iv)(["font-size:", ";padding:10px 45px;"], function (_ref7) {
    var theme = _ref7.theme;
    return theme.fontSize['lg'];
  });
}, function (props) {
  return props.cornered && (0,styled_components_browser_esm/* css */.iv)(["border-radius:4px;"]);
}, function (props) {
  return props.rounded && (0,styled_components_browser_esm/* css */.iv)(["border-radius:50px;"]);
}, function (props) {
  return props.outline && (0,styled_components_browser_esm/* css */.iv)(["background-color:transparent;border:1px solid ", ";"], function (_ref8) {
    var theme = _ref8.theme;
    return theme.backgroundColors[props.backgroundColor || 'primary'];
  });
}, function (props) {
  return props.block && (0,styled_components_browser_esm/* css */.iv)(["display:block;width:100%;"]);
}, function (props) {
  return props.variant === 'category' && (0,styled_components_browser_esm/* css */.iv)(["font-family:", ";font-size:16px;height:48px;font-weight:600;padding:0 24px;"], function (_ref9) {
    var theme = _ref9.theme;
    return theme.fontFamily['manrope'];
  });
}, function (props) {
  return props.variant === 'offering' && (0,styled_components_browser_esm/* css */.iv)(["font-family:", ";background-color:", ";border:1ps solid ", ";font-size:14px;height:36px;font-weight:600;padding:0 20px;&:hover{background-color:", "!important;}"], function (_ref10) {
    var theme = _ref10.theme;
    return theme.fontFamily['manrope'];
  }, function (props) {
    return props.theme.backgroundColors.lighterBlue;
  }, function (props) {
    return props.theme.backgroundColors.lightBlue;
  }, function (props) {
    return props.theme.backgroundColors.lightBlue;
  });
}, function (_ref11) {
  var theme = _ref11.theme,
      color = _ref11.color;
  return theme.textColors[color || 'white'];
}, function (_ref12) {
  var theme = _ref12.theme,
      backgroundColor = _ref12.backgroundColor;
  return theme.backgroundColors[backgroundColor || 'primary'];
}, function (props) {
  return props.outline && (0,styled_components_browser_esm/* css */.iv)(["background-color:transparent;color:", ";border:1px solid ", ";"], function (_ref13) {
    var theme = _ref13.theme;
    return theme.textColors[props.color || 'white'];
  }, function (_ref14) {
    var theme = _ref14.theme;
    return theme.backgroundColors[props.backgroundColor || 'primary'];
  });
});
/* harmony default export */ var styled_Button = (Button);
;// CONCATENATED MODULE: ./styled/Divider.tsx

var Divider = styled_components_browser_esm/* default.hr.withConfig */.ZP.hr.withConfig({
  displayName: "Divider",
  componentId: "sc-jmaqtz-0"
})(["margin-top:", ";margin-bottom:", ";border:0;opacity:0.2;border-top:1px solid ", ";"], function (_ref) {
  var margin = _ref.margin;
  return margin;
}, function (_ref2) {
  var margin = _ref2.margin;
  return margin;
}, function (_ref3) {
  var color = _ref3.color;
  return color || 'white';
});
/* harmony default export */ var styled_Divider = (Divider);
;// CONCATENATED MODULE: ./constants/contactInformation.ts
var contactNumber = '+91-85 8888 7480';
var emailAddress = 'contact@ezylegal.in';
// EXTERNAL MODULE: ./constants/deviceTypes.ts
var deviceTypes = __webpack_require__(1821);
;// CONCATENATED MODULE: ./utils/openWhatsapp.ts



function getInternationalFormattedNum() {
  return contactNumber.replace('+', '').replace('-', '').split(' ').join('');
}

function openWhatsapp(device) {
  var internationalFormattedNum = getInternationalFormattedNum();
  if (device === deviceTypes/* DeviceTypes.DESKTOP */.h.DESKTOP) window.open('https://web.whatsapp.com/send?phone=' + internationalFormattedNum);else window.open('https://api.whatsapp.com/send?phone=' + internationalFormattedNum);
}
function getWhatsappLink() {
  var internationalFormattedNum = getInternationalFormattedNum();
  return 'https://web.whatsapp.com/send?phone=' + internationalFormattedNum;
}
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ./components/WhatsappFooterButton/WhatsappFooterButton.tsx






var WhatsappFooterButton = function WhatsappFooterButton(_ref) {
  var device = _ref.device;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(FloatingGreeting, {
      onClick: function onClick() {
        openWhatsapp(device);
      },
      style: {
        cursor: 'pointer'
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(FooterContainer, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FooterContainerMessage, {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "row",
            style: {
              alignItems: 'center'
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "col-10",
              style: {
                paddingRight: 0
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(MessageContent, {
                children: ["Hi there \uD83D\uDC4B! ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  style: {
                    fontSize: 15,
                    paddingBottom: 0,
                    marginBottom: 0
                  },
                  children: "How can I help you?"
                })]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "col-2",
              style: {
                paddingRight: 0,
                paddingLeft: 0
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(FooterContainerIconFrame, {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  src: "/city-lawyers/icons/whatsapp.svg",
                  width: "34",
                  alt: "whatsapp",
                  height: 'auto'
                })
              })
            })]
          })
        })
      })
    })
  });
};

/* harmony default export */ var WhatsappFooterButton_WhatsappFooterButton = (WhatsappFooterButton);
// EXTERNAL MODULE: ./components/useResponsiveDevice.ts
var useResponsiveDevice = __webpack_require__(9556);
// EXTERNAL MODULE: ./utils/toasts.ts
var toasts = __webpack_require__(3200);
// EXTERNAL MODULE: ./api/backendApi.ts
var backendApi = __webpack_require__(5484);
// EXTERNAL MODULE: ./constants/queries/user.tsx
var user = __webpack_require__(5691);
// EXTERNAL MODULE: ../../node_modules/lozad/dist/lozad.min.js
var lozad_min = __webpack_require__(788);
var lozad_min_default = /*#__PURE__*/__webpack_require__.n(lozad_min);
// EXTERNAL MODULE: ./api/config.js
var config = __webpack_require__(76);
;// CONCATENATED MODULE: ./components/Footer/Footer.tsx
















 // const ZENDESK_KEY = 'cda34b4e-33b3-423c-9ced-053740ee0306';





var FooterJumpTop = function FooterJumpTop() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    style: {
      zIndex: 200,
      position: "absolute",
      display: "grid",
      width: "60px",
      height: "60px",
      borderRadius: "50%",
      marginTop: "-50px",
      left: "50%",
      backgroundColor: "#396aeb",
      cursor: "pointer",
      alignContent: "center",
      gap: ".4rem",
      transform: "translateX(-50%)"
    },
    className: "d-flex flex-column justify-content-center align-items-center",
    onClick: function onClick() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
      width: "12",
      height: "8",
      viewBox: "0 0 12 8",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M1.41 7.41L6 2.83L10.59 7.41L12 6L6 0L0 6L1.41 7.41Z",
        fill: "white"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
      weight: "bold",
      color: "white",
      className: "mb-0",
      children: "TOP"
    })]
  });
};

var Footer = function Footer(_ref) {
  var _footer$footer_leftco, _footer$footer_leftco2, _footer$footer_rightc, _footer$footer_rightc2, _footer$footer_rightc3, _footer$footer_rightc4, _footer$footer_rightc5, _footer$footer_rightc6, _footer$footer_rightc7;

  var footer1Menu = _ref.footer1Menu,
      isHome = _ref.isHome,
      device = _ref.device,
      footer = _ref.footer;

  var _useResponsiveDevice = (0,useResponsiveDevice/* default */.Z)(),
      isMobile = _useResponsiveDevice.isMobile;

  var _useState = (0,react.useState)(""),
      email = _useState[0],
      setEmail = _useState[1];

  var handleSubscribe = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var _res$data$errors, res;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return backendApi/* default.post */.Z.post("/", {
                query: user/* SUBSCRIBE_TO_NEWSLETER */.Xo,
                variables: {
                  email: email
                }
              });

            case 3:
              res = _context.sent;

              if (!((_res$data$errors = res.data.errors) !== null && _res$data$errors !== void 0 && _res$data$errors.length)) {
                _context.next = 6;
                break;
              }

              throw new Error(res.data.errors[0].message);

            case 6:
              (0,toasts/* successToast */.Qm)("Successfully subscribed to newsletter");
              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);

              if (_context.t0 instanceof Error) {
                (0,toasts/* errorToast */.Jc)(_context.t0.message);
              }

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 9]]);
    }));

    return function handleSubscribe() {
      return _ref2.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(function () {
    var observer = lozad_min_default()(".lozad", {
      rootMargin: "10px 0px",
      // syntax similar to that of CSS Margin
      threshold: 0.1 // ratio of element convergence

    });
    observer.observe(); // let new_sectionLink = {name: 'Find Lawyers', link: 'find-all-lawyers-in-cities', target: '_blank'}
    // footer?.footer_rightcontainer?.sections.sectionlinks.splice(2,0,new_sectionLink)
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(FooterTop, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FooterJumpTop, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "row align-items-center",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "col-12 col-md",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
              fontSize: "xxxl",
              color: "white",
              weight: "bold",
              children: "ezyLegal"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "col-12 col-md"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "col-12 col-md-5",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
              fontSize: "lg",
              fontFamily: "montserrat",
              color: "white",
              weight: "bold",
              className: "mb-0",
              children: "Get Useful tips and Product info"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
              size: 16,
              direction: "vertical"
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "d-flex",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
                className: "form-control",
                placeholder: "Your Email Id",
                value: email,
                onChange: function onChange(event) {
                  return setEmail(event.target.value);
                }
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
                direction: "horizontal",
                size: 15
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(styled_Button, {
                size: "md",
                cornered: true,
                onClick: handleSubscribe,
                children: "Signup"
              })]
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styled_Divider, {
          color: "white",
          margin: "40px"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "row",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "col-12 col-md-4",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
              color: "white",
              fontSize: "lg",
              weight: "midbold",
              children: footer === null || footer === void 0 ? void 0 : (_footer$footer_leftco = footer.footer_leftcontainer) === null || _footer$footer_leftco === void 0 ? void 0 : _footer$footer_leftco.about.heading
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
              color: "white",
              fontSize: "md",
              weight: "semibold",
              children: footer === null || footer === void 0 ? void 0 : (_footer$footer_leftco2 = footer.footer_leftcontainer) === null || _footer$footer_leftco2 === void 0 ? void 0 : _footer$footer_leftco2.about.description
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
              size: 20,
              direction: "vertical"
            }), footer !== null && footer !== void 0 && (_footer$footer_rightc = footer.footer_rightcontainer) !== null && _footer$footer_rightc !== void 0 && (_footer$footer_rightc2 = _footer$footer_rightc.sections) !== null && _footer$footer_rightc2 !== void 0 && (_footer$footer_rightc3 = _footer$footer_rightc2.sectionlinks) !== null && _footer$footer_rightc3 !== void 0 && _footer$footer_rightc3.length ? /*#__PURE__*/(0,jsx_runtime.jsx)(FooterMenu, {
              children: footer.footer_rightcontainer.sections.sectionlinks.map(function (menu) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                    href: "".concat(config/* Site_url */.Z, "/").concat(menu.link),
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "md",
                        weight: "midbold",
                        color: "white",
                        children: menu.name
                      })
                    })
                  })
                }, "link-".concat(menu.name));
              })
            }) : null]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "col-12 col-md-8",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "row justify-content-between",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "col-12 col-md-auto",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
                  color: "white",
                  fontSize: "lg",
                  weight: "midbold",
                  children: footer === null || footer === void 0 ? void 0 : footer.footer_rightcontainer.secondSections.heading
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer2Menu, {
                  children: footer === null || footer === void 0 ? void 0 : footer.footer_rightcontainer.secondSections.sectionlinks.map(function (item, index) {
                    if (item.name == 'Download App') {
                      return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
                            color: "white",
                            fontSize: "md",
                            weight: "semibold",
                            children: item.name
                          })
                        }, index), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                          className: "row",
                          style: {
                            marginLeft: '0px'
                          },
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                            href: item.link,
                            target: '_blank',
                            rel: "noopener noreferrer",
                            children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                              src: "/city-lawyers/images/google-play.png"
                            })
                          })
                        })]
                      });
                    } else {
                      return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                          href: "".concat(config/* Site_url */.Z, "/").concat(item.link),
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
                              color: "white",
                              fontSize: "md",
                              weight: "semibold",
                              children: item.name
                            })
                          })
                        })
                      }, index);
                    }
                  })
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "col-12 col-md-auto",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
                  color: "white",
                  fontSize: "lg",
                  weight: "midbold",
                  children: footer === null || footer === void 0 ? void 0 : (_footer$footer_rightc4 = footer.footer_rightcontainer) === null || _footer$footer_rightc4 === void 0 ? void 0 : (_footer$footer_rightc5 = _footer$footer_rightc4.thirdSections) === null || _footer$footer_rightc5 === void 0 ? void 0 : _footer$footer_rightc5.heading
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer2Menu, {
                  children: footer === null || footer === void 0 ? void 0 : (_footer$footer_rightc6 = footer.footer_rightcontainer) === null || _footer$footer_rightc6 === void 0 ? void 0 : (_footer$footer_rightc7 = _footer$footer_rightc6.thirdSections) === null || _footer$footer_rightc7 === void 0 ? void 0 : _footer$footer_rightc7.sectionlinks.map(function (item, index) {
                    return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                        href: "".concat(config/* Site_url */.Z, "/").concat(item.link),
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
                            color: "white",
                            fontSize: "md",
                            weight: "semibold",
                            children: item.name
                          })
                        })
                      })
                    }, index);
                  })
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "col-12 col-md-auto",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
                  color: "white",
                  fontSize: "lg",
                  weight: "midbold",
                  children: "Socials"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(FooterMenu, {
                  children: footer === null || footer === void 0 ? void 0 : footer.footer_leftcontainer.social.map(function (social, index) {
                    var iconSrc = "";

                    switch (social.name) {
                      case "Twitter":
                        iconSrc = "/city-lawyers/icons/twitter.svg";
                        break;

                      case "LinkedIn":
                        iconSrc = "/city-lawyers/icons/linkedin.svg";
                        break;

                      case "Instagram":
                        iconSrc = "/city-lawyers/icons/instagram.svg";
                        break;

                      case "Facebook":
                        iconSrc = "/city-lawyers/icons/facebook.svg";
                        break;

                      case "YouTube":
                        iconSrc = "/city-lawyers/icons/youtube.svg";
                        break;
                    }

                    return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                      style: {
                        position: social.name == "Twitter" || social.name == "YouTube" ? "relative" : "unset",
                        top: social.name == "Twitter" || social.name == "YouTube" ? "3px" : "",
                        marginLeft: social.name == "Twitter" || social.name == "YouTube" ? "3px" : ""
                      },
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                        href: social.link,
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                          target: "_blank",
                          rel: "noopener noreferrer",
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                            "data-src": iconSrc,
                            width: 20,
                            height: 20,
                            alt: social.alttext,
                            className: "lozad"
                          })
                        })
                      })
                    }, index);
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
                  size: 10,
                  direction: "vertical"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
                  color: "white",
                  weight: "midbold",
                  fontSize: "lg",
                  children: "Contact Us"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                  href: "mailto:" + emailAddress,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Text/* default */.Z, {
                      color: "white",
                      fontSize: "md",
                      weight: "semibold",
                      block: true,
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                        "data-src": "/city-lawyers/icons/email_24px.svg",
                        width: "16",
                        alt: "email",
                        className: "lozad mr-2"
                      }), emailAddress]
                    })
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                  href: "tel:" + contactNumber,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Text/* default */.Z, {
                      color: "white",
                      fontSize: "md",
                      block: true,
                      weight: "semibold",
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                        "data-src": "/city-lawyers/icons/phone_24px.svg",
                        width: "16",
                        alt: "phone",
                        className: "lozad mr-2"
                      }), contactNumber]
                    })
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
                  size: 10,
                  direction: "vertical"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
                  color: "white",
                  fontSize: "lg",
                  weight: "midbold",
                  children: "Our Location"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
                  color: "white",
                  fontSize: "md",
                  weight: "semibold",
                  children: "Space Creattors Heights,"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
                  color: "white",
                  fontSize: "md",
                  weight: "semibold",
                  children: "3rd Floor, Landmark Cyberpark, Sector 67,"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
                  color: "white",
                  fontSize: "md",
                  weight: "semibold",
                  children: "Gurgaon (Haryana) - 122018"
                })]
              })]
            })
          })]
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer_styled_Footer, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "row",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "col-12 col-md-8",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
              color: "white",
              fontSize: "sm",
              weight: "normal",
              children: "\xA9 2023 Neo Online Ventures Pvt Ltd. All rights reserved."
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Text/* default */.Z, {
              color: "white",
              fontSize: "sm",
              weight: "normal",
              children: ["ezyLegal is not a law firm, or a substitute for a lawyer or law firm. We are also not a \"lawyer referral service\". Use of this website will be at the sole risk of the user. Use of any service will not create any lawyer-client relationship.", /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
                direction: "vertical",
                size: 15
              }), "ezyLegal will not be liable for any consequence of any action taken by the user relying on information or services provided under this website. In cases where the user has any legal issues, he/she in all cases must seek independent legal advice.", /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
                direction: "vertical",
                size: 15
              }), "Use of our products and services are governed by our", /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: "".concat(config/* Site_url */.Z, "termsandconditions"),
                children: " Terms of Use "
              }), " and", /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: "".concat(config/* Site_url */.Z, "privacy"),
                children: " Privacy Policy "
              }), "."]
            })]
          })
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(WhatsappFooterButton_WhatsappFooterButton, {
      device: device
    })]
  });
};

/* harmony default export */ var Footer_Footer = (Footer);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
// EXTERNAL MODULE: ../../node_modules/react-bootstrap/esm/Accordion.js + 3 modules
var Accordion = __webpack_require__(7104);
// EXTERNAL MODULE: ../../node_modules/react-bootstrap/esm/Navbar.js + 3 modules
var Navbar = __webpack_require__(4331);
;// CONCATENATED MODULE: ./components/SlideDrawer/SlideDrawer.styled.tsx

var SlideDrawerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SlideDrawerstyled__SlideDrawerWrapper",
  componentId: "sc-yo308g-0"
})(["height:100%;background:white;position:fixed;top:0;left:0;width:80%;z-index:200;box-shadow:1px 0px 7px rgba(0,0,0,0.5);transform:translateX(-110%);transition:transform 0.3s ease-out;border-radius:0 20px 20px 0;padding:15px 0;overflow-y:scroll;&::-webkit-scrollbar{width:0 !important;}", ""], function (props) {
  return props.isOpen && (0,styled_components_browser_esm/* css */.iv)(["transform:translateX(0);"]);
});
;// CONCATENATED MODULE: ./components/SlideDrawer/index.tsx



var SlideDrawer = function SlideDrawer(_ref) {
  var nodeRef = _ref.nodeRef,
      isOpen = _ref.isOpen,
      children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(SlideDrawerWrapper, {
    ref: nodeRef,
    isOpen: isOpen,
    children: children
  });
};

/* harmony default export */ var components_SlideDrawer = (SlideDrawer);
// EXTERNAL MODULE: ./components/CorneredBox/index.tsx + 1 modules
var CorneredBox = __webpack_require__(742);
// EXTERNAL MODULE: ../../node_modules/react-bootstrap/esm/Dropdown.js + 71 modules
var Dropdown = __webpack_require__(8709);
// EXTERNAL MODULE: ../../node_modules/react-bootstrap/esm/NavDropdown.js
var NavDropdown = __webpack_require__(5577);
// EXTERNAL MODULE: ../../node_modules/react-bootstrap/esm/Card.js + 1 modules
var Card = __webpack_require__(6586);
;// CONCATENATED MODULE: ./components/Header/Header.styled.tsx



var DropdownTogle = (0,styled_components_browser_esm/* default */.ZP)(Dropdown/* default.Toggle */.Z.Toggle).withConfig({
  displayName: "Headerstyled__DropdownTogle",
  componentId: "sc-1xh3a8w-0"
})(["background:#fff;color:black;border:2px solid lightgray;border-radius:25px;padding:10px 25px;&.active{background-color:#f1f9fe;border-top:2px solid #0078db;border-bottom:2px solid transparent;border:none;}"]);
var NavLink = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
  displayName: "Headerstyled__NavLink",
  componentId: "sc-1xh3a8w-1"
})(["padding:1rem 1rem;color:", ";margin-bottom:0px !important;min-height:80px;line-height:50px;&.active{background-color:#f1f9fe;border-top:2px solid #0078db;border-bottom:2px solid transparent;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.textColors['black'];
});
var StyledNavDropdown = (0,styled_components_browser_esm/* default */.ZP)(NavDropdown/* default */.Z).withConfig({
  displayName: "Headerstyled__StyledNavDropdown",
  componentId: "sc-1xh3a8w-2"
})(["position:static;& .nav-link{padding:1rem 1rem !important;height:80px;line-height:50px;&:after{background-image:url(\"data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1.41 0.294922L6 4.87492L10.59 0.294922L12 1.70492L6 7.70492L0 1.70492L1.41 0.294922Z' fill='black' fill-opacity='0.54'/%3E%3C/svg%3E%0A\");width:12px;height:8px;background-size:contain;background-repeat:no-repeat;margin-left:7px;border:none;transform:translateY(2px);}p{margin-bottom:0;color:#000;}}& > .dropdown-menu{border-radius:0 0 18px 18px;width:100%;padding:0;border:0;box-shadow:0px 1px 30px rgba(0,0,0,0.11);top:calc(100% + 1px);}"]);
var StyledNavbar = (0,styled_components_browser_esm/* default */.ZP)(Navbar/* default */.Z).withConfig({
  displayName: "Headerstyled__StyledNavbar",
  componentId: "sc-1xh3a8w-3"
})(["background-color:transparent !important;padding:0 1rem;& .navbar-brand{padding-top:1rem;padding-bottom:1rem;}"]);
var CardBox = (0,styled_components_browser_esm/* default */.ZP)(Card/* default */.Z).withConfig({
  displayName: "Headerstyled__CardBox",
  componentId: "sc-1xh3a8w-4"
})(["border-radius:0 !important;border:0;"]);
// @ts-ignore
// @ts-ignore
var CardHeader = (0,styled_components_browser_esm/* default */.ZP)(Card/* default.Header */.Z.Header, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'border';
  }
}).withConfig({
  displayName: "Headerstyled__CardHeader",
  componentId: "sc-1xh3a8w-5"
})(["background-color:transparent;border-radius:0 !important;border:0;padding:10px 20px;border-bottom:", ";"], function (props) {
  return props.border ? '1px solid #dad8d8' : 'none';
});
var CardBody = (0,styled_components_browser_esm/* default */.ZP)(Card/* default.Body */.Z.Body).withConfig({
  displayName: "Headerstyled__CardBody",
  componentId: "sc-1xh3a8w-6"
})(["background-color:transparent;padding:0 0 0 20px;"]);
var LinkText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
  displayName: "Headerstyled__LinkText",
  componentId: "sc-1xh3a8w-7"
})(["padding:10px 20px;margin:0;"]);
var MenuButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "Headerstyled__MenuButton",
  componentId: "sc-1xh3a8w-8"
})(["background-color:transparent;border:0;margin-right:0.5rem!important;"]);
var SignInDropdown = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "Headerstyled__SignInDropdown",
  componentId: "sc-1xh3a8w-9"
})(["margin:0;background-color:#ffffff;color:#09b2e8;border:2px solid #e5e5e5;padding:0 0 0 1em;position:absolute;z-index:100;width:200px;border-radius:10px;box-shadow:0px 1px 30px rgb(0 0 0 / 11%);&.hide{display:none;}"]);
var SignInDropdownElement = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  displayName: "Headerstyled__SignInDropdownElement",
  componentId: "sc-1xh3a8w-10"
})(["list-style:none;margin-bottom:0.8em;cursor:pointer;&.colors{color:#396ae8;font-weight:bold;}"]);
var HeaderDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Headerstyled__HeaderDiv",
  componentId: "sc-1xh3a8w-11"
})(["background-color:rgb(255,255,255);border-radius:0px 0px 18px 18px;box-shadow:rgb(0 0 0 / 25%) 0px 1px 0px;width:100%;padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto;margin-bottom:1px;"]);
// EXTERNAL MODULE: ../../node_modules/react-bootstrap/esm/Modal.js + 22 modules
var Modal = __webpack_require__(9626);
;// CONCATENATED MODULE: ./components/LoginPopup/LoginPopup.styled.tsx


var LoginModal = (0,styled_components_browser_esm/* default */.ZP)(Modal/* default */.Z).withConfig({
  displayName: "LoginPopupstyled__LoginModal",
  componentId: "sc-14b0qya-0"
})(["& .modal-content{border:none;border-radius:0;}@media only screen and (max-width:767px){.modal-header{border-bottom:none;.close{color:white;}}}"]);
var ModalBody = (0,styled_components_browser_esm/* default */.ZP)(Modal/* default.Body */.Z.Body).withConfig({
  displayName: "LoginPopupstyled__ModalBody",
  componentId: "sc-14b0qya-1"
})(["padding:0 15px;"]);
var ModalHeader = (0,styled_components_browser_esm/* default */.ZP)(Modal/* default.Header */.Z.Header).withConfig({
  displayName: "LoginPopupstyled__ModalHeader",
  componentId: "sc-14b0qya-2"
})(["background-color:", ";border-bottom:unset;& > .close{color:", ";}"], function (_ref) {
  var theme = _ref.theme,
      backgroundColor = _ref.backgroundColor;
  return theme.backgroundColors[backgroundColor || 'primary'];
}, function (_ref2) {
  var theme = _ref2.theme,
      color = _ref2.color;
  return theme.backgroundColors[color || 'white'];
});
var LoginLeftSideBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LoginPopupstyled__LoginLeftSideBox",
  componentId: "sc-14b0qya-3"
})(["background-color:", ";width:100%;padding:30px 40px;"], function (_ref3) {
  var theme = _ref3.theme,
      backgroundColor = _ref3.backgroundColor;
  return theme.backgroundColors[backgroundColor || 'primary'];
});
var LoginRightSideBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LoginPopupstyled__LoginRightSideBox",
  componentId: "sc-14b0qya-4"
})(["width:100%;max-width:350px;min-height:450px;margin:auto;display:flex;justify-content:center;align-items:center;& > div{width:100%;padding:40px 0;}input.form-control{font-family:", ";height:44px;border:1px solid #8993a4;border-radius:4px;font-size:14px;}.countrySelect{& > div{height:44px;border:1px solid #8993a4;}}.bottomLink{font-size:16px;font-weight:700;button{font-weight:700;font-size:16px;}}"], function (props) {
  return props.theme.fontFamily.manrope;
});
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(3955);
// EXTERNAL MODULE: ../../node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(6812);
// EXTERNAL MODULE: ../../node_modules/yup/es/index.js + 26 modules
var es = __webpack_require__(5413);
// EXTERNAL MODULE: ../../node_modules/yup-phone/dist/yup-phone.umd.js
var yup_phone_umd = __webpack_require__(2702);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 18 modules
var react_redux_es = __webpack_require__(2772);
// EXTERNAL MODULE: ./utils/selectCountry.ts
var selectCountry = __webpack_require__(3152);
// EXTERNAL MODULE: ../../node_modules/react-flags-select/build/index.esm.js
var build_index_esm = __webpack_require__(7832);
;// CONCATENATED MODULE: ./components/LoginPopup/LoginBox/Step1.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


















var LoginFormWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Step1__LoginFormWrapper",
  componentId: "sc-vrhc0n-0"
})(["input.form-control{font-family:", ";height:44px;border:1px solid #8993a4;border-radius:4px;font-size:14px;}.countrySelect{& > div{height:44px;border:1px solid #8993a4;}}.bottomLink{font-size:16px;font-weight:700;button{font-weight:700;font-size:16px;}}"], function (props) {
  return props.theme.fontFamily.manrope;
});
var customStyles = {
  control: function control() {
    return {
      innerHeight: '44px'
    };
  }
};

var Step1 = function Step1(_ref) {
  var setTab = _ref.setTab,
      setLoginData = _ref.setLoginData;
  var geolocation = (0,react_redux_es/* useSelector */.v9)(function (store) {
    return store.location.geolocation;
  });

  var _useState = (0,react.useState)(geolocation == 'in' ? '91' : '1'),
      code = _useState[0],
      setCode = _useState[1];

  var _useState2 = (0,react.useState)(geolocation == 'in' ? 'IN' : 'US'),
      country = _useState2[0],
      setCountry = _useState2[1];

  var loginSchema = country == "IN" ? es.object().shape({
    mobile: es.string().phone().test('len', function (val, _ref2) {
      var createError = _ref2.createError,
          path = _ref2.path;
      return (val === null || val === void 0 ? void 0 : val.length) === 10 ? true : createError({
        path: path,
        message: 'Phone number should be valid and 10 digits long'
      });
    }).required()
  }) : es.object().shape({
    mobile: es.string().required()
  });

  var setCountryCode = function setCountryCode(code) {
    var country = (0,selectCountry/* default */.Z)(code);
    setCode(country);
    setCountry(code);
  };

  (0,react.useEffect)(function () {
    loginSchema = country == "IN" ? es.object().shape({
      mobile: es.string().phone().test('len', function (val, _ref3) {
        var createError = _ref3.createError,
            path = _ref3.path;
        return (val === null || val === void 0 ? void 0 : val.length) === 10 ? true : createError({
          path: path,
          message: 'Phone number should be valid and 10 digits long'
        });
      }).required()
    }) : es.object().shape({
      mobile: es.string().required()
    });
  }, [country]);

  var _useForm = (0,index_esm/* useForm */.cI)({
    resolver: (0,yup/* yupResolver */.X)(loginSchema),
    defaultValues: {
      mobile: ''
    }
  }),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      control = _useForm.control,
      errors = _useForm.formState.errors,
      getValues = _useForm.getValues;

  var onSubmit = function onSubmit(data) {
    backendApi/* default.post */.Z.post('/', {
      query: user/* LOGIN_QUERY */.Go,
      variables: {
        mobile: parseFloat(data.mobile),
        countryCode: parseInt(code)
      }
    }).then(function (res) {
      if (res.data.data) {
        setLoginData(res.data.data.loginUser);
      } else if (res.data.errors.length) {
        throw new Error(res.data.errors[0].message);
      }
    })["catch"](function (error) {
      (0,toasts/* errorToast */.Jc)(error.message);
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(LoginFormWrapper, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
      onSubmit: handleSubmit(onSubmit),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
        fontSize: "lg",
        color: "gray",
        weight: "midbold",
        children: "Login by Mobile No."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
        direction: "vertical",
        size: 15
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "d-flex",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(build_index_esm/* default */.ZP, {
            selected: country,
            onSelect: function onSelect(code) {
              setCountryCode(code);
            },
            countries: ["IN", "US", "GB", "CA", "ZA", "AU", "SG", "MY", "AE", "SA"],
            optionsSize: 14,
            customLabels: {
              "IN": "+91",
              "US": "+1",
              "GB": "+44",
              "CA": "+1",
              "ZA": "+27",
              "AU": "+61",
              "SG": "+65",
              "MY": "+60",
              "AE": "+971",
              "SA": "+966"
            }
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
          direction: "horizontal",
          size: 6
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "w-100",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("input", _objectSpread({
            className: "form-control",
            placeholder: "Enter valid mobile no.",
            "data-clarity-unmask": "True"
          }, register('mobile')))
        })]
      }), errors.mobile && /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
        color: "red",
        fontSize: "xs",
        children: "Invalid mobile number"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
        direction: "vertical",
        size: 30
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(styled_Button, {
        size: "md",
        block: true,
        rounded: true,
        color: "white",
        backgroundColor: "primary",
        children: "Login"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
        direction: "vertical",
        size: 100
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Text/* default */.Z, {
        center: true,
        fontSize: "md",
        color: "gray",
        className: "bottomLink",
        children: ["New to EzyLegal?", /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
          as: "button",
          fontSize: "md",
          inline: true,
          color: "primary",
          style: {
            background: 'transparent',
            border: 'unset'
          },
          onClick: function onClick() {
            return setTab('SIGNUP');
          },
          children: "Create an Account"
        })]
      })]
    })
  });
};

/* harmony default export */ var LoginBox_Step1 = (Step1);
// EXTERNAL MODULE: ../../node_modules/react-otp-input/lib/index.js
var lib = __webpack_require__(4607);
// EXTERNAL MODULE: ./redux/loggedInUser/loggedInUser.actions.ts + 1 modules
var loggedInUser_actions = __webpack_require__(6486);
;// CONCATENATED MODULE: ./components/LoginPopup/LoginBox/Step2.tsx














var Step2 = function Step2(_ref) {
  var loginData = _ref.loginData,
      setLoginData = _ref.setLoginData,
      handleClose = _ref.handleClose;

  var _useState = (0,react.useState)(''),
      otp = _useState[0],
      setOtp = _useState[1];

  var dispatch = (0,react_redux_es/* useDispatch */.I0)();
  (0,react.useEffect)(function () {
    function otpRequest() {
      return _otpRequest.apply(this, arguments);
    }

    function _otpRequest() {
      _otpRequest = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var abortController, timer, o, content;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!('OTPCredential' in window)) {
                  _context.next = 9;
                  break;
                }

                abortController = new AbortController();
                timer = setTimeout(function () {
                  abortController.abort();
                }, 20 * 1000);
                o = {
                  otp: {
                    transport: ['sms']
                  },
                  signal: abortController.signal
                };
                _context.next = 6;
                return window.navigator['credentials'].get(o);

              case 6:
                content = _context.sent;
                alert(content === null || content === void 0 ? void 0 : content.type);
                if (content !== null) setOtp(content.id); //do what ever you want to do with the received code, probably send it to server

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _otpRequest.apply(this, arguments);
    }

    otpRequest();
  }, []);

  var handleLogin = function handleLogin() {
    dispatch((0,loggedInUser_actions/* verifyOtp */.Mu)({
      mobile: loginData.mobile,
      otp: otp,
      countryCode: loginData.country_code
    }, function () {
      handleClose();
    }));
  };

  var forceOtpSend = function forceOtpSend() {
    var forceOtp = {
      mobile: loginData.mobile,
      countryCode: loginData.country_code
    };

    try {
      dispatch((0,loggedInUser_actions/* loginUser */.pH)(forceOtp, function () {
        (0,toasts/* successToast */.Qm)('Otp sent successfully!');
      }));
    } catch (e) {
      if (e instanceof Error) {
        (0,toasts/* errorToast */.Jc)(e.message);
      }
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Text/* default */.Z, {
      fontSize: "md",
      color: "gray",
      children: ["Enter OTP sent to your Mobile No. ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " +", loginData.country_code, "-", loginData.mobile, /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
        as: "button",
        fontSize: "md",
        inline: true,
        color: "primary",
        style: {
          background: 'transparent',
          border: 'unset'
        },
        onClick: function onClick() {
          return setLoginData(null);
        },
        children: "Change"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
      direction: "vertical",
      size: 15
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.Z, {
      value: otp,
      onChange: setOtp,
      inputStyle: {
        width: '100%',
        height: '55px',
        borderRadius: '5px',
        border: '1px solid #396AE8'
      },
      containerStyle: {
        gap: '20px'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
      direction: "vertical",
      size: 30
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(styled_Button, {
      size: "md",
      block: true,
      rounded: true,
      color: "white",
      backgroundColor: "primary",
      onClick: handleLogin,
      children: "Login Now"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
      direction: "vertical",
      size: 60
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Text/* default */.Z, {
      fontSize: "md",
      color: "gray",
      children: ["If OTP is not received", /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
        as: "button",
        fontSize: "md",
        inline: true,
        color: "primary",
        style: {
          background: 'transparent',
          border: 'unset'
        },
        onClick: forceOtpSend,
        children: "Send Again"
      })]
    })]
  });
};

/* harmony default export */ var LoginBox_Step2 = (Step2);
;// CONCATENATED MODULE: ./components/LoginPopup/LoginBox/index.tsx









var LoginBox = function LoginBox(_ref) {
  var setTab = _ref.setTab,
      handleClose = _ref.handleClose;

  var _useState = (0,react.useState)(null),
      loginData = _useState[0],
      setLoginData = _useState[1];

  var _useResponsiveDevice = (0,useResponsiveDevice/* default */.Z)(),
      isMobile = _useResponsiveDevice.isMobile;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "row",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "col-0 col-md-5 p-0 d-flex",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(LoginLeftSideBox, {
        backgroundColor: "primary",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
          color: "white",
          fontSize: "xxxl",
          fontFamily: "montserrat",
          weight: "bold",
          children: "Login"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Text/* default */.Z, {
          color: "white",
          fontSize: "lg",
          children: ["Get access to your Orders at ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "one place"]
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "col-12 col-md-7 p-0",
      children: [!isMobile && /*#__PURE__*/(0,jsx_runtime.jsx)(ModalHeader, {
        closeButton: true,
        backgroundColor: "white",
        color: 'primary'
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LoginRightSideBox, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: loginData ? /*#__PURE__*/(0,jsx_runtime.jsx)(LoginBox_Step2, {
            loginData: loginData,
            setLoginData: setLoginData,
            handleClose: handleClose
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(LoginBox_Step1, {
            setTab: setTab,
            setLoginData: setLoginData
          })
        })
      })]
    })]
  });
};

/* harmony default export */ var LoginPopup_LoginBox = (LoginBox);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ./utils/deviceInfoService.ts
var deviceInfoService = __webpack_require__(6902);
// EXTERNAL MODULE: ./utils/getLocation.ts + 1 modules
var getLocation = __webpack_require__(1272);
;// CONCATENATED MODULE: ./components/LoginPopup/SignupBox.tsx




function SignupBox_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function SignupBox_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { SignupBox_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { SignupBox_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }























var SignupBox = function SignupBox(_ref) {
  var _errors$name, _errors$email, _errors$company, _errors$gst;

  var setTab = _ref.setTab,
      handleClose = _ref.handleClose;
  var router = (0,next_router.useRouter)();
  var geolocation = (0,react_redux_es/* useSelector */.v9)(function (store) {
    return store.location.geolocation;
  });

  var _useState = (0,react.useState)(geolocation == 'in' ? '91' : '1'),
      code = _useState[0],
      setCode = _useState[1];

  var _useState2 = (0,react.useState)(geolocation == 'in' ? 'IN' : 'US'),
      country = _useState2[0],
      setCountry = _useState2[1];

  var setCountryCode = function setCountryCode(code) {
    var country = (0,selectCountry/* default */.Z)(code);
    setCode(country);
    setCountry(code);
  };

  var signupSchema = country == 'IN' ? es.object().shape({
    type: es.string().required(),
    name: es.string().required('Full Name is required'),
    email: es.string().email().required('Email is required'),
    mobile: es.string().phone().test('len', function (val, _ref2) {
      var createError = _ref2.createError,
          path = _ref2.path;
      return (val === null || val === void 0 ? void 0 : val.length) === 10 ? true : createError({
        path: path,
        message: 'Phone number should be valid and 10 digits long'
      });
    }).required(),
    company: es.string().when('type', {
      is: 'Business',
      then: es.string().required(),
      otherwise: es.string()
    }),
    gst: es.string().when('type', {
      is: 'Business',
      then: es.string().required(),
      otherwise: es.string()
    })
  }) : es.object().shape({
    type: es.string().required(),
    name: es.string().required('Full Name is required'),
    email: es.string().email().required('Email is required'),
    mobile: es.string().required(),
    company: es.string().when('type', {
      is: 'Business',
      then: es.string().required(),
      otherwise: es.string()
    }),
    gst: es.string().when('type', {
      is: 'Business',
      then: es.string().required(),
      otherwise: es.string()
    })
  });

  var _useForm = (0,index_esm/* useForm */.cI)({
    resolver: (0,yup/* yupResolver */.X)(signupSchema),
    defaultValues: {
      name: '',
      type: 'INDIVIDUAL',
      email: '',
      mobile: '',
      company: '',
      gst: ''
    }
  }),
      register = _useForm.register,
      unregister = _useForm.unregister,
      handleSubmit = _useForm.handleSubmit,
      control = _useForm.control,
      watch = _useForm.watch,
      errors = _useForm.formState.errors;

  var watchedType = watch('type');
  var dispatch = (0,react_redux_es/* useDispatch */.I0)();
  (0,react.useEffect)(function () {
    if (watchedType === 'INDIVIDUAL') {
      unregister(['company', 'gst']);
    }
  }, [watchedType]);

  var _useState3 = (0,react.useState)({}),
      deviceDetails = _useState3[0],
      setDeviceDetails = _useState3[1];

  var _useResponsiveDevice = (0,useResponsiveDevice/* default */.Z)(),
      isMobile = _useResponsiveDevice.isMobile;

  (0,react.useEffect)(function () {
    var getDetails = /*#__PURE__*/function () {
      var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var ip, result;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0,getLocation/* getLocation */.k)();

              case 2:
                ip = _context.sent;
                // const device = await getDeviceDetails();
                result = {
                  device: '',
                  device_type: isMobile ? 'Mobile' : 'Desktop',
                  ip_address: ip ? ip : '',
                  path: (0,deviceInfoService/* getPageURL */.VQ)(),
                  userAgent: (0,deviceInfoService/* getUserAgent */.ij)()
                };
                setDeviceDetails(SignupBox_objectSpread({}, result));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getDetails() {
        return _ref3.apply(this, arguments);
      };
    }();

    getDetails();
  }, []);
  (0,react.useEffect)(function () {
    signupSchema = country == 'in' ? es.object().shape({
      type: es.string().required(),
      name: es.string().required('Full Name is required'),
      email: es.string().email().required('Email is required'),
      mobile: es.string().phone().test('len', function (val, _ref4) {
        var createError = _ref4.createError,
            path = _ref4.path;
        return (val === null || val === void 0 ? void 0 : val.length) === 10 ? true : createError({
          path: path,
          message: 'Phone number should be valid and 10 digits long'
        });
      }).required(),
      company: es.string().when('type', {
        is: 'Business',
        then: es.string().required(),
        otherwise: es.string()
      }),
      gst: es.string().when('type', {
        is: 'Business',
        then: es.string().required(),
        otherwise: es.string()
      })
    }) : es.object().shape({
      type: es.string().required(),
      name: es.string().required('Full Name is required'),
      email: es.string().email().required('Email is required'),
      mobile: es.string().required(),
      company: es.string().when('type', {
        is: 'Business',
        then: es.string().required(),
        otherwise: es.string()
      }),
      gst: es.string().when('type', {
        is: 'Business',
        then: es.string().required(),
        otherwise: es.string()
      })
    });
  }, [country]);

  var onSubmit = function onSubmit(data) {
    var _deviceDetails$ip_add;

    data.countryCode = code;

    var signUpData = SignupBox_objectSpread(SignupBox_objectSpread({}, data), {}, {
      countryCode: code,
      country: geolocation,
      user_ip_address: deviceDetails === null || deviceDetails === void 0 ? void 0 : (_deviceDetails$ip_add = deviceDetails.ip_address) === null || _deviceDetails$ip_add === void 0 ? void 0 : _deviceDetails$ip_add.query,
      user_agent: deviceDetails === null || deviceDetails === void 0 ? void 0 : deviceDetails.userAgent,
      page_url: deviceDetails === null || deviceDetails === void 0 ? void 0 : deviceDetails.path,
      device_type: deviceDetails === null || deviceDetails === void 0 ? void 0 : deviceDetails.device_type,
      source: 'SIGN_UP_BOX'
    });

    dispatch((0,loggedInUser_actions/* signUp */.y1)(signUpData, function () {
      handleClose();
      var url = window.location.href;

      if (url.includes('aii')) {
        router.push('/profile');
      }
    }));
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "row",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "col-0 col-md-5 p-0 d-flex",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(LoginLeftSideBox, {
        backgroundColor: "primary",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
          color: "white",
          fontSize: "xxxl",
          fontFamily: "montserrat",
          weight: "bold",
          children: "Create an Account"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Text/* default */.Z, {
          color: "white",
          fontSize: "lg",
          children: ["You can track all services at ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " one place"]
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "col-12 col-md-7 p-0",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ModalHeader, {
        closeButton: true,
        backgroundColor: "white",
        color: 'primary'
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LoginRightSideBox, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
            onSubmit: handleSubmit(onSubmit),
            className: "registerForm",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
              fontSize: "lg",
              color: "gray",
              weight: "midbold",
              children: "Create an Account"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
              direction: "vertical",
              size: 20
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
              fontSize: "md",
              weight: "semibold",
              color: "label",
              children: "Your Name"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", SignupBox_objectSpread({
              className: "form-control",
              "data-clarity-unmask": "True",
              placeholder: "Enter your Full name"
            }, register('name'))), errors.name && /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
              color: "red",
              fontSize: "xs",
              children: (_errors$name = errors.name) === null || _errors$name === void 0 ? void 0 : _errors$name.message
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
              direction: "vertical",
              size: 20
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
              fontSize: "md",
              weight: "semibold",
              color: "label",
              children: "Email Address"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", SignupBox_objectSpread({
              className: "form-control",
              "data-clarity-unmask": "True",
              placeholder: "Enter your Email Address"
            }, register('email'))), errors.email && /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
              color: "red",
              fontSize: "xs",
              children: (_errors$email = errors.email) === null || _errors$email === void 0 ? void 0 : _errors$email.message
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
              direction: "vertical",
              size: 20
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
              fontSize: "md",
              weight: "semibold",
              color: "label",
              children: "Mobile No."
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "d-flex w-100",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(build_index_esm/* default */.ZP, {
                  selected: country,
                  onSelect: function onSelect(code) {
                    setCountryCode(code);
                  },
                  countries: ['IN', 'US', 'GB', 'CA', 'ZA', 'AU', 'SG', 'MY', 'AE', 'SA'],
                  optionsSize: 14,
                  customLabels: {
                    IN: '+91',
                    US: '+1',
                    GB: '+44',
                    CA: '+1',
                    ZA: '+27',
                    AU: '+61',
                    SG: '+65',
                    MY: '+60',
                    AE: '+971',
                    SA: '+966'
                  }
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
                direction: "horizontal",
                size: 10
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "w-100",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("input", SignupBox_objectSpread({
                  className: "form-control",
                  "data-clarity-unmask": "True",
                  placeholder: "Enter valid mobile no."
                }, register('mobile')))
              })]
            }), errors.mobile ? /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
              color: "red",
              fontSize: "xs",
              children: "Invalid mobile number"
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
              fontSize: "xs",
              children: "Enter a valid phone number"
            }), watchedType === 'COMPANY' ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
                direction: "vertical",
                size: 20
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
                fontSize: "sm",
                color: "label",
                children: "Company Name"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", SignupBox_objectSpread({
                className: "form-control",
                "data-clarity-unmask": "True",
                placeholder: "Enter your Company Name"
              }, register('company'))), errors.company && /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "red",
                fontSize: "xs",
                children: (_errors$company = errors.company) === null || _errors$company === void 0 ? void 0 : _errors$company.message
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
                direction: "vertical",
                size: 20
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
                fontSize: "sm",
                color: "label",
                children: "GST Number"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", SignupBox_objectSpread({
                className: "form-control",
                "data-clarity-unmask": "True",
                placeholder: "Companies GST number"
              }, register('gst'))), errors.gst && /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "red",
                fontSize: "xs",
                children: (_errors$gst = errors.gst) === null || _errors$gst === void 0 ? void 0 : _errors$gst.message
              })]
            }) : null, /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
              direction: "vertical",
              size: 20
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(styled_Button, {
              size: "md",
              block: true,
              rounded: true,
              color: "white",
              backgroundColor: "primary",
              children: "Create Account"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
              direction: "vertical",
              size: 60
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Text/* default */.Z, {
              center: true,
              fontSize: "md",
              color: "gray",
              className: "bottomLink",
              children: ["Already a User?", /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
                as: "button",
                fontSize: "md",
                inline: true,
                color: "primary",
                style: {
                  background: 'transparent',
                  border: 'unset'
                },
                onClick: function onClick() {
                  return setTab('LOGIN');
                },
                children: "Login here"
              })]
            })]
          })
        })
      })]
    })]
  });
};

/* harmony default export */ var LoginPopup_SignupBox = (SignupBox);
;// CONCATENATED MODULE: ./components/LoginPopup/index.tsx






var LoginPopup = function LoginPopup(_ref) {
  var show = _ref.show,
      handleClose = _ref.handleClose,
      tabValue = _ref.tabValue,
      setTab = _ref.setTab,
      mobileView = _ref.mobileView;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(LoginModal, {
    show: show,
    onHide: handleClose,
    centered: true,
    size: "xl",
    children: [mobileView ? /*#__PURE__*/(0,jsx_runtime.jsx)(ModalHeader, {
      color: "primary",
      closeButton: true
    }) : null, /*#__PURE__*/(0,jsx_runtime.jsx)(ModalBody, {
      children: tabValue === 'LOGIN' ? /*#__PURE__*/(0,jsx_runtime.jsx)(LoginPopup_LoginBox, {
        setTab: setTab,
        handleClose: handleClose
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(LoginPopup_SignupBox, {
        setTab: setTab,
        handleClose: handleClose
      })
    })]
  });
};

/* harmony default export */ var components_LoginPopup = (LoginPopup);
// EXTERNAL MODULE: ./redux/newCheckout/newCheckout.actions.ts
var newCheckout_actions = __webpack_require__(5000);
;// CONCATENATED MODULE: ./utils/shouldRedirectOnLogout.ts
function shouldRedirectOnLogout(path) {
  switch (path) {
    case '/payment-summary':
      return true;

    case '/profile':
      return true;

    case '/dashboard':
      return true;
  }

  return false;
}

/* harmony default export */ var utils_shouldRedirectOnLogout = (shouldRedirectOnLogout);
;// CONCATENATED MODULE: ./components/Header/MobileHeader.tsx


function MobileHeader_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function MobileHeader_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { MobileHeader_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { MobileHeader_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



 // import { useSwipeable } from 'react-swipeable';











 // import styled from 'styled-components';





var AccordionMenu = function AccordionMenu(_ref) {
  var menu = _ref.menu,
      depth = _ref.depth,
      isOpen = _ref.isOpen;

  var _useState = (0,react.useState)(""),
      activeKey = _useState[0],
      setActiveKey = _useState[1];

  depth++;
  if (!menu) return null;

  var clickHandler = function clickHandler(i, e) {
    var _document$getElementB;

    e.preventDefault();
    window.location.href = "https://www.ezylegal.in".concat(i);
    document.body.removeAttribute("style");
    (_document$getElementB = document.getElementById("cornered_box")) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.removeAttribute("style");
    isOpen();
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Accordion/* default */.Z, {
    activeKey: activeKey,
    onSelect: function onSelect(i) {
      return setActiveKey(i);
    },
    children: menu === null || menu === void 0 ? void 0 : menu.map(function (menu, i) {
      return menu.children.length ? /*#__PURE__*/(0,jsx_runtime.jsxs)(CardBox, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CardHeader, {
          border: depth === 1 ? 1 : 0,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Accordion/* default.Toggle */.Z.Toggle, {
            as: "span",
            eventKey: String(i),
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "row",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "col",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
                  as: "a",
                  fontSize: depth === 1 ? "lg" : "md",
                  block: true,
                  children: menu.label
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "col-auto",
                children: activeKey === String(i) ? /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  src: "/city-lawyers/icons/keyboard_arrow_up.svg",
                  alt: "Up",
                  width: "12"
                }) : /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  src: "/city-lawyers/icons/keyboard_arrow_down.svg",
                  alt: "Down",
                  width: "12"
                })
              })]
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Accordion/* default.Collapse */.Z.Collapse, {
          eventKey: String(i),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CardBody, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(AccordionMenu, {
              menu: menu.children,
              depth: depth,
              isOpen: isOpen
            })
          })
        })]
      }, i) : /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: menu.url,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkText, {
          onClick: function onClick(e) {
            return clickHandler(menu.url, e);
          },
          fontSize: depth === 1 ? "lg" : "md",
          as: "a",
          block: true,
          children: menu.label
        })
      }, i);
    })
  });
};

var MobileLogin = function MobileLogin() {
  var _useState2 = (0,react.useState)({
    show: false,
    tabValue: "LOGIN"
  }),
      showModal = _useState2[0],
      setShowModal = _useState2[1];

  var router = (0,next_router.useRouter)();

  var setTab = function setTab(tabValue) {
    setShowModal(MobileHeader_objectSpread(MobileHeader_objectSpread({}, showModal), {}, {
      tabValue: tabValue
    }));
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkText, {
        color: "gray-500",
        children: "For Customers"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      onClick: function onClick() {
        var elem = document.querySelector("body");

        if (elem) {
          elem.style.overflow = "unset";
          setShowModal({
            show: true,
            tabValue: "REGISTER"
          });
        }
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkText, {
        children: "Register Now"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      onClick: function onClick() {
        var elem = document.querySelector("body");

        if (elem) {
          elem.style.overflow = "unset";
          setShowModal({
            show: true,
            tabValue: "Login"
          });
        }
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkText, {
        children: "Login"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkText, {
        color: "gray-500",
        children: "For Lawyers & CA"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      onClick: function onClick() {
        var elem = document.querySelector("body");

        if (elem) {
          elem.style.overflow = "unset";
          var newPath = "".concat(config/* Site_url */.Z, "join-our-network?register=true");
          window.location.href = newPath; // router.push({
          //   pathname: "/join-our-network",
          //   query: { register: true },
          // });
        }
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkText, {
        children: "Register"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      onClick: function onClick() {
        var elem = document.querySelector("body");

        if (elem) {
          elem.style.overflow = "unset";
          var newPath = "".concat(config/* Site_url */.Z, "join-our-network");
          window.location.href = newPath; // router.push({
          //   pathname: "/join-our-network",
          // });
        }
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkText, {
        children: "Login"
      })
    }), showModal.show && /*#__PURE__*/(0,jsx_runtime.jsx)(components_LoginPopup, {
      tabValue: showModal.tabValue,
      show: showModal.show,
      handleClose: function handleClose() {
        setShowModal({
          show: false,
          tabValue: "LOGIN"
        });
      },
      setTab: setTab,
      mobileView: true
    })]
  });
};

var UserInfo = function UserInfo(_ref2) {
  var name = _ref2.name,
      type = _ref2.type;
  var dispatch = (0,react_redux_es/* useDispatch */.I0)();
  var router = (0,next_router.useRouter)();
  var loggedInUserData = (0,react_redux_es/* useSelector */.v9)(function (store) {
    return store.loggedInUser;
  });
  var asPath = router.asPath;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkText, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Text/* default */.Z, {
          color: "gray-500",
          children: [" Hi, ", name, " "]
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      onClick: function onClick() {
        if (type === "AGENT") {
          var newPath = window.location.origin + "/expert/profile";
          window.location.replace(newPath);
        } else {
          var _newPath = "".concat(config/* Site_url */.Z, "profile");

          window.location.href = _newPath; // router.push("/profile");
        }
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkText, {
        children: "My Profile"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      onClick: function onClick() {
        var newPath = "".concat(config/* Site_url */.Z, "dashboard");
        window.location.href = newPath; // router.push("/dashboard");
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkText, {
        children: " My Orders "
      })
    }), type === "AGENT" ? /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      onClick: function onClick() {
        var newPath = window.location.origin + "/expert/";
        window.location.replace(newPath);
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkText, {
        children: " My Dashboard "
      })
    }) : null, (loggedInUserData === null || loggedInUserData === void 0 ? void 0 : loggedInUserData.user_type) !== "AGENT" && loggedInUserData !== null && loggedInUserData !== void 0 && loggedInUserData.organization && (loggedInUserData === null || loggedInUserData === void 0 ? void 0 : loggedInUserData.organization) !== "" ? /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      onClick: function onClick() {
        var newPath = "".concat(config/* Site_url */.Z, "business/?_id=").concat(loggedInUserData._id, "&token=").concat(loggedInUserData.jwt_token);
        window.location.href = newPath;
        localStorage.setItem("business_checkout", "1");
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkText, {
        children: " My Business "
      })
    }) : null, /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      onClick: function onClick() {
        localStorage.removeItem("ezyLegalUserData");
        localStorage.removeItem("persist:root");
        localStorage.removeItem("persist:lawyerRoot");
        dispatch((0,loggedInUser_actions/* setLoggedInUser */.yM)(null));
        dispatch((0,newCheckout_actions/* updateNewCheckoutState */.C$)({
          newUserData: null
        }));

        if (utils_shouldRedirectOnLogout(asPath)) {
          router.push("/");
        }
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkText, {
        children: " Logout "
      })
    })]
  });
};

var MobileHeader = function MobileHeader(_ref3) {
  var headerMenu = _ref3.headerMenu,
      bgColorBack = _ref3.bgColorBack,
      widthSize = _ref3.widthSize;

  var _useState3 = (0,react.useState)(false),
      isOpen = _useState3[0],
      setIsOpen = _useState3[1];

  var nodeRef = (0,react.useRef)(); // const { ref } = useSwipeable({
  //   trackTouch: true,
  //   onSwipedRight: () => setIsOpen(true),
  //   onSwipedLeft: () => setIsOpen(false),
  // }) as { ref: RefCallback<Document> };

  (0,react.useEffect)(function () {
    var handleClickOutside = function handleClickOutside(e) {
      var _document$getElementB2;

      if (nodeRef.current && nodeRef.current.contains(e.target)) {
        // inside click
        return;
      } // outside click


      setIsOpen(false);
      document.body.removeAttribute("style");
      (_document$getElementB2 = document.getElementById("cornered_box")) === null || _document$getElementB2 === void 0 ? void 0 : _document$getElementB2.removeAttribute("style");
    };

    document.addEventListener("mousedown", handleClickOutside); // ref(document);

    return function () {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  (0,react.useEffect)(function () {
    if (!isOpen) {
      document.body.removeAttribute("style");
    }
  }, [isOpen]);
  var loggedInUserData = (0,react_redux_es/* useSelector */.v9)(function (store) {
    return store.loggedInUser;
  });

  var MenuBackDrop = function MenuBackDrop() {
    var _document$getElementB3;

    document.body.style.overflow = "hidden";
    (_document$getElementB3 = document.getElementById("cornered_box")) === null || _document$getElementB3 === void 0 ? void 0 : _document$getElementB3.setAttribute("style", "position: fixed;;width: 100%;height: 100%;top: 0;left: 0;right: 0;bottom: 0;background-color: rgba(0,0,0,0.5);z-index: 201;cursor: pointer;");
  };

  var close = function close() {
    setIsOpen(false);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HeaderDiv, {
      className: "container py-2 position-relative",
      style: {
        zIndex: 999
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "row align-items-center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "col",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "d-flex align-items-center",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(MenuButton, {
              onClick: function onClick() {
                setIsOpen(!isOpen);
                MenuBackDrop();
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                src: "/city-lawyers/icons/menu_24px.svg",
                alt: "Menu",
                width: "35"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: "https://www.ezylegal.in",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Navbar/* default.Brand */.Z.Brand, {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  src: "/city-lawyers/images/logo.svg",
                  alt: "Logo",
                  height: "50",
                  className: "d-inline-block align-text-top"
                })
              })
            })]
          })
        }), isOpen ? /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          id: "close",
          style: {
            zIndex: 200,
            fontSize: 25,
            fontWeight: 400,
            color: "white"
          },
          className: widthSize ? widthSize > 910 ? "" : "col-2" : "col-2",
          onClick: function onClick(e) {
            e.preventDefault();
            setIsOpen(false);
          },
          children: "X"
        }) : ""]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CorneredBox/* default */.Z, {
      zIndex: 1,
      bgColor: "white",
      bgColorBack: bgColorBack,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(components_SlideDrawer, {
        nodeRef: nodeRef,
        isOpen: isOpen,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "logo p-4",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: "/city-lawyers/images/logo.svg",
            alt: "Logo",
            height: "40",
            className: "d-inline-block align-text-top"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(AccordionMenu, {
          menu: headerMenu,
          depth: 1,
          isOpen: close
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("hr", {}), loggedInUserData !== null && loggedInUserData !== void 0 && loggedInUserData.name ? /*#__PURE__*/(0,jsx_runtime.jsx)(UserInfo, {
          name: loggedInUserData === null || loggedInUserData === void 0 ? void 0 : loggedInUserData.name,
          type: loggedInUserData.user_type
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(MobileLogin, {})]
      })
    })]
  });
};

/* harmony default export */ var Header_MobileHeader = (MobileHeader);
// EXTERNAL MODULE: ../../node_modules/react-bootstrap/esm/Nav.js + 3 modules
var Nav = __webpack_require__(1591);
;// CONCATENATED MODULE: ./components/ActiveLink/index.tsx




var ActiveLink = function ActiveLink(_ref) {
  var href = _ref.href,
      children = _ref.children;
  var router = (0,next_router.useRouter)();
  var className = router.pathname === href ? "active" : "";
  var child = react.Children.only(children);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
    onClick: function onClick() {
      window.location.href = "https://www.ezylegal.in".concat(href);
    },
    children: /*#__PURE__*/react.cloneElement(child, {
      className: className || null
    })
  });
};

/* harmony default export */ var components_ActiveLink = (ActiveLink);
;// CONCATENATED MODULE: ./components/Header/DropDownContainer.tsx







var DropdownItem = function DropdownItem(_ref) {
  var menu = _ref.menu,
      handleClose = _ref.handleClose,
      showDropdown = _ref.showDropdown;

  var _useState = (0,react.useState)(false),
      showMore = _useState[0],
      setShowMore = _useState[1];

  var _useState2 = (0,react.useState)([]),
      menuItems = _useState2[0],
      setMenuItems = _useState2[1];

  (0,react.useEffect)(function () {
    if (!showMore) {
      setMenuItems(menu.children.filter(function (_, index) {
        return index < 4;
      }));
    } else {
      setMenuItems(menu.children);
    }
  }, [showMore]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
    className: "list-unstyled",
    children: [menuItems.map(function (menu) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        className: "mb-2",
        onClick: function onClick() {
          return handleClose();
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_ActiveLink, {
          href: menu.url,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            style: {
              color: '#000'
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
              fontSize: "base",
              weight: "normal",
              children: menu.label
            })
          })
        }, menu.label)
      }, menu.label);
    }), menu.children.length > 4 ? /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
      className: "mb-2",
      children: showMore ? /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
        onClick: function onClick() {
          return setShowMore(false);
        },
        children: [' ', /*#__PURE__*/(0,jsx_runtime.jsxs)(Text/* default */.Z, {
          fontSize: "md",
          color: "primary",
          children: [' ', "Show Less", ' ']
        }), ' ']
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
        onClick: function onClick() {
          return setShowMore(true);
        },
        children: [' ', /*#__PURE__*/(0,jsx_runtime.jsxs)(Text/* default */.Z, {
          fontSize: "md",
          color: "primary",
          children: [' ', "Show More"]
        }), ' ']
      })
    }, "show") : null]
  });
};

var DropDownContainer = function DropDownContainer(_ref2) {
  var menu = _ref2.menu,
      handleClose = _ref2.handleClose,
      showDropdown = _ref2.showDropdown;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "container  py-4",
    style: {
      display: showDropdown ? 'block' : 'none'
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "row",
      children: menu.children.map(function (menuItem) {
        if (menuItem.label === 'Legal Consultation') {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "col-12 col-md-3",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(DropdownItem, {
              menu: menu,
              handleClose: handleClose,
              showDropdown: true
            })
          });
        } else {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
            children: menuItem.children.length ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "col-12 col-md-3",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
                fontSize: "base",
                fontFamily: "manrope",
                weight: "bold",
                children: menuItem.label
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
                direction: "vertical",
                size: 10
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(DropdownItem, {
                menu: menuItem,
                handleClose: handleClose,
                showDropdown: true
              })]
            }) : null
          }, menuItem.id);
        }
      })
    })
  });
};

/* harmony default export */ var Header_DropDownContainer = (DropDownContainer);
;// CONCATENATED MODULE: ./components/Header/DesktopHeader.tsx


function DesktopHeader_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function DesktopHeader_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { DesktopHeader_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { DesktopHeader_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








 // import SlideSearchBox from '../SlideSearchBox';














var DesktopHeader = function DesktopHeader(_ref) {
  var headerMenu = _ref.headerMenu,
      bgColorBack = _ref.bgColorBack;

  var _useState = (0,react.useState)({
    show: false,
    tabValue: 'LOGIN'
  }),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var _useState2 = (0,react.useState)(true),
      showMenu = _useState2[0],
      setShowMenu = _useState2[1];

  var router = (0,next_router.useRouter)();
  var asPath = router.asPath;

  var _useState3 = (0,react.useState)(false),
      showDropdown = _useState3[0],
      setShowDropdown = _useState3[1];

  var _useState4 = (0,react.useState)(''),
      hoverId = _useState4[0],
      setHoverId = _useState4[1];

  var dispatch = (0,react_redux_es/* useDispatch */.I0)();
  var loggedInUserData = (0,react_redux_es/* useSelector */.v9)(function (store) {
    return store.loggedInUser;
  });

  var _useState5 = (0,react.useState)(false),
      showSignInDropdown = _useState5[0],
      setShowSignInDropdown = _useState5[1];

  var handleClose = function handleClose() {
    setIsOpen(DesktopHeader_objectSpread(DesktopHeader_objectSpread({}, isOpen), {}, {
      show: false
    }));
  };

  var Signout_User = function Signout_User() {
    localStorage.removeItem('ezyLegalUserData');
    dispatch((0,loggedInUser_actions/* setLoggedInUser */.yM)(null));
    dispatch((0,newCheckout_actions/* updateNewCheckoutState */.C$)({
      newUserData: null
    }));
    if (utils_shouldRedirectOnLogout(asPath)) router.push('/');
  };

  var wrapperRef = (0,react.useRef)(null);
  (0,react.useEffect)(function () {
    function handleOutsideClick(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowSignInDropdown(false);
      }
    }

    document.addEventListener('mousedown', handleOutsideClick);
    return function () {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [wrapperRef]);

  var setTab = function setTab(value) {
    setIsOpen(DesktopHeader_objectSpread(DesktopHeader_objectSpread({}, isOpen), {}, {
      tabValue: value
    }));
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(CorneredBox/* default */.Z, {
    bgColor: "white",
    bgColorBack: bgColorBack,
    innerClassName: "header_top",
    zIndex: 180,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledNavbar, {
      expand: "lg",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container d-flex",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "https://www.ezylegal.in",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Navbar/* default.Brand */.Z.Brand, {
              style: {
                width: '180px'
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                src: "/city-lawyers/images/logo.svg",
                alt: "EzyLegal Logo",
                width: "180",
                className: "d-inline-block align-text-top"
              })
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Navbar/* default.Collapse */.Z.Collapse, {
          id: "basic-navbar-nav",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Nav/* default */.Z, {
            className: "m-auto",
            children: headerMenu === null || headerMenu === void 0 ? void 0 : headerMenu.map(function (menu) {
              return menu.children.length ? /*#__PURE__*/(0,jsx_runtime.jsx)(StyledNavDropdown, {
                title: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
                  inline: true,
                  weight: "midbold",
                  fontSize: "md",
                  children: menu.label
                }),
                id: menu.id,
                show: menu.id == hoverId && showDropdown && true,
                onMouseEnter: function onMouseEnter() {
                  setShowDropdown(true);
                  setHoverId(menu.id);
                },
                onMouseLeave: function onMouseLeave() {
                  setShowDropdown(false);
                  setHoverId('');
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Header_DropDownContainer, {
                  menu: menu,
                  showDropdown: showDropdown,
                  handleClose: function handleClose() {
                    setTimeout(function () {
                      setShowDropdown(false);
                    }, 1000);
                  }
                })
              }, menu.id) : /*#__PURE__*/(0,jsx_runtime.jsx)(components_ActiveLink, {
                href: menu.linkRelationship === 'legal-consultation' ? '/legal-consultation' : menu.url,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(NavLink, {
                    fontSize: "md",
                    weight: "midbold",
                    children: menu.label
                  })
                })
              }, menu.id);
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            style: {
              display: 'flex',
              width: '26%',
              gap: '1rem',
              justifyContent: 'flex-end'
            },
            children: !(loggedInUserData !== null && loggedInUserData !== void 0 && loggedInUserData.name) ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              style: {
                position: 'relative'
              },
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styled_Button, {
                size: "md",
                rounded: true,
                style: {
                  width: '150px',
                  fontSize: '16px',
                  fontWeight: 700
                },
                onClick: function onClick() {
                  return setShowSignInDropdown(true);
                },
                children: "Sign In"
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SignInDropdown, {
                ref: wrapperRef,
                className: showSignInDropdown ? 'show py-3' : 'hide py-3',
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
                  fontSize: "md",
                  color: "gray-500",
                  weight: "midbold",
                  children: "For Customers"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(SignInDropdownElement, {
                  className: "colors",
                  onClick: function onClick() {
                    setIsOpen({
                      show: true,
                      tabValue: 'LOGIN'
                    });
                    setShowSignInDropdown(false);
                  },
                  children: "Login"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(SignInDropdownElement, {
                  className: "colors",
                  onClick: function onClick() {
                    setIsOpen({
                      show: true,
                      tabValue: 'REGISTER'
                    });
                    setShowSignInDropdown(false);
                  },
                  children: "Register"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
                  direction: "horizontal",
                  size: 10
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
                  fontSize: "md",
                  color: "gray-500",
                  weight: "bold",
                  children: "For Lawyers & CA"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(SignInDropdownElement, {
                  className: "colors",
                  onClick: function onClick() {
                    var newPath = "".concat(config/* Site_url */.Z, "join-our-network");
                    window.location.href = newPath; // router.push('/join-our-network')
                  },
                  children: "Login"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(SignInDropdownElement, {
                  className: "colors",
                  onClick: function onClick() {
                    var newPath = "".concat(config/* Site_url */.Z, "join-our-network?register=true");
                    window.location.href = newPath; // router.push({
                    //   pathname: '/join-our-network',
                    //   query: { register: true },
                    // });
                  },
                  children: "Register"
                })]
              })]
            }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(Dropdown/* default */.Z, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DropdownTogle, {
                id: "dropdown-basic",
                children: loggedInUserData === null || loggedInUserData === void 0 ? void 0 : loggedInUserData.name.split(' ')[0]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Dropdown/* default.Menu */.Z.Menu, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Dropdown/* default.Item */.Z.Item, {
                  onClick: function onClick() {
                    if ((loggedInUserData === null || loggedInUserData === void 0 ? void 0 : loggedInUserData.user_type) === 'AGENT') {
                      var newPath = window.location.origin + '/expert/profile';
                      window.location.replace(newPath);
                    } else {
                      var _newPath = "".concat(config/* Site_url */.Z, "profile");

                      window.location.href = _newPath; // router.push('/profile');
                    }
                  },
                  children: "My Profile"
                }), (loggedInUserData === null || loggedInUserData === void 0 ? void 0 : loggedInUserData.user_type) === 'AGENT' ? /*#__PURE__*/(0,jsx_runtime.jsx)(Dropdown/* default.Item */.Z.Item, {
                  onClick: function onClick() {
                    router.push('/dashboard');
                  },
                  children: "My Orders"
                }) : null, /*#__PURE__*/(0,jsx_runtime.jsx)(Dropdown/* default.Item */.Z.Item, {
                  onClick: function onClick() {
                    if ((loggedInUserData === null || loggedInUserData === void 0 ? void 0 : loggedInUserData.user_type) === 'AGENT') {
                      var newPath = window.location.origin + '/expert/';
                      window.location.replace(newPath);
                    } else {
                      var _newPath2 = "".concat(config/* Site_url */.Z, "dashboard");

                      window.location.href = _newPath2; // router.push('/dashboard');
                    }
                  },
                  children: (loggedInUserData === null || loggedInUserData === void 0 ? void 0 : loggedInUserData.user_type) === 'AGENT' ? 'My Dashboard' : 'My Orders'
                }), (loggedInUserData === null || loggedInUserData === void 0 ? void 0 : loggedInUserData.user_type) !== 'AGENT' && loggedInUserData !== null && loggedInUserData !== void 0 && loggedInUserData.organization && (loggedInUserData === null || loggedInUserData === void 0 ? void 0 : loggedInUserData.organization) !== '' ? /*#__PURE__*/(0,jsx_runtime.jsx)(Dropdown/* default.Item */.Z.Item, {
                  onClick: function onClick() {
                    var newPath = "".concat(config/* Site_url */.Z, "business/?_id=").concat(loggedInUserData._id, "&token=").concat(loggedInUserData.jwt_token);
                    window.location.href = newPath;
                    localStorage.setItem('business_checkout', '1');
                  },
                  children: "My Business"
                }) : null, /*#__PURE__*/(0,jsx_runtime.jsx)(Dropdown/* default.Item */.Z.Item, {
                  onClick: function onClick() {
                    return Signout_User();
                  },
                  children: "Sign out"
                })]
              })]
            })
          })]
        })]
      })
    }), isOpen && /*#__PURE__*/(0,jsx_runtime.jsx)(components_LoginPopup, {
      tabValue: isOpen.tabValue,
      show: isOpen.show,
      handleClose: handleClose,
      setTab: setTab
    })]
  });
};

/* harmony default export */ var Header_DesktopHeader = (DesktopHeader);
;// CONCATENATED MODULE: ./components/Header/index.tsx





var Header = function Header(_ref) {
  var headerMenu = _ref.headerMenu,
      bgColorBack = _ref.bgColorBack,
      device = _ref.device,
      widthSize = _ref.widthSize;

  switch (device) {
    case deviceTypes/* DeviceTypes.MOBILE */.h.MOBILE:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Header_MobileHeader, {
        headerMenu: headerMenu,
        bgColorBack: bgColorBack,
        widthSize: widthSize
      });

    case deviceTypes/* DeviceTypes.DESKTOP */.h.DESKTOP:
      if (widthSize) {
        if (widthSize < 992) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Header_MobileHeader, {
            headerMenu: headerMenu,
            bgColorBack: bgColorBack,
            widthSize: widthSize
          });
        } else {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Header_DesktopHeader, {
            headerMenu: headerMenu,
            bgColorBack: bgColorBack
          });
        }
      } else {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Header_DesktopHeader, {
          headerMenu: headerMenu,
          bgColorBack: bgColorBack
        });
      }

    default:
      return null;
  }
};

/* harmony default export */ var components_Header = (Header);
;// CONCATENATED MODULE: ./components/MainLayout/MainWrapper.tsx


var MainWrapper = function MainWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("main", {
    className: "main-wrapper",
    children: children
  });
};

/* harmony default export */ var MainLayout_MainWrapper = (MainWrapper);
;// CONCATENATED MODULE: ./components/MainLayout/index.tsx











var MainLayout = function MainLayout(_ref) {
  var menus = _ref.menus,
      headerBgColorBack = _ref.headerBgColorBack,
      isHome = _ref.isHome,
      children = _ref.children,
      footer = _ref.footer;

  var _useState = (0,react.useState)(deviceTypes/* DeviceTypes.DESKTOP */.h.DESKTOP),
      device = _useState[0],
      setDevice = _useState[1];

  var _useState2 = (0,react.useState)(null),
      widthSize = _useState2[0],
      setWidthSize = _useState2[1];

  var showLoader = (0,react_redux_es/* useSelector */.v9)(function (state) {
    return state.loader;
  });
  (0,react.useLayoutEffect)(function () {
    var handleResize = function handleResize() {
      setDevice(window.innerWidth < 768 ? deviceTypes/* DeviceTypes.MOBILE */.h.MOBILE : deviceTypes/* DeviceTypes.DESKTOP */.h.DESKTOP);
      setWidthSize(window.innerWidth);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return function () {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  (0,react.useEffect)(function () {
    var userData = localStorage.getItem("ezyLegalUserData");

    if (userData === null) {
      dispatch((0,loggedInUser_actions/* setLoggedInUser */.yM)(null));
    }
  }, []);
  var dispatch = (0,react_redux_es/* useDispatch */.I0)();
  return (
    /*#__PURE__*/
    // <LoadingOverlay active={showLoader.showLoader} spinner text={'Please wait'}>
    //   <div
    //     className="d-flex flex-column justify-content-between"
    //     style={{
    //       minHeight: '100vh',
    //     }}
    //   >
    (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_Header, {
        headerMenu: (menus === null || menus === void 0 ? void 0 : menus.header) || [],
        bgColorBack: headerBgColorBack || "white",
        device: device,
        widthSize: widthSize
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(MainLayout_MainWrapper, {
        children: children
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer_Footer, {
        footer1Menu: (menus === null || menus === void 0 ? void 0 : menus.footer1) || [],
        isHome: isHome,
        device: device,
        footer: footer
      })]
    }) // </LoadingOverlay>

  );
};

/* harmony default export */ var components_MainLayout = (MainLayout);

/***/ }),

/***/ 7435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_StickyFooterCityLawyers; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(8526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
;// CONCATENATED MODULE: ./components/StickyFooterB/StickyFooterB.styled.tsx

var ComponentFooter = styled_components_browser_esm/* default.footer.withConfig */.ZP.footer.withConfig({
  displayName: "StickyFooterBstyled__ComponentFooter",
  componentId: "sc-i4i2ul-0"
})(["background-color:#FEF5E6;display:block;width:100%;left:0;right:0;position:fixed;box-shadow:0px -4px 6px rgba(31,92,163,.3);"]);
var FooterButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "StickyFooterBstyled__FooterButton",
  componentId: "sc-i4i2ul-1"
})(["background-color:#396AE8;color:#FFFFFF;border:none;display:block;text-align:center;font-size:16px;white-space:nowrap;padding:.4rem .6rem;border-radius:50px;width:100%;@media(max-width:380px){font-size:10px;}"]);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(2772);
// EXTERNAL MODULE: ./api/config.js
var config = __webpack_require__(76);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ./components/StickyFooterCityLawyers/index.tsx





 //Component design by Juan Tua 26/01/2022//




var StickyFooterCityLawyers = function StickyFooterCityLawyers(_ref) {
  var data = _ref.data;
  var router = (0,next_router.useRouter)();
  var geolocation = (0,es/* useSelector */.v9)(function (store) {
    return store.location.geolocation;
  });

  var purchaseTalktime = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var newPath;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              newPath = "".concat(config/* Site_url */.Z, "legal-consultation/checkout?min=3&concernedArea=Other%20Legal%20Problem");
              window.location.href = newPath; // router.push("/legal-consultation");

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function purchaseTalktime() {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsx)("footer", {
    className: "footer mt-auto   text-white",
    style: {
      backgroundColor: "rgb(253, 245, 237)",
      display: "block",
      position: "fixed",
      width: "100%",
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 75,
      height: 58,
      border: "2px solid #DBDDE6"
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      style: {
        maxWidth: 1280,
        margin: "0 auto",
        padding: " 0 15",
        height: "100%"
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "row",
        style: {
          height: "100%",
          alignItems: "center"
        },
        "data-clarity-unmask": "True",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          style: {
            marginLeft: 20,
            flex: " 0 0 8.666667%",
            maxWidth: "16.666667%"
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: "/city-lawyers/icons/call.svg",
            style: {
              width: 20,
              height: 20,
              "float": "left",
              marginRight: 10,
              marginLeft: 10
            },
            alt: "call"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "col-6",
          style: {
            marginBottom: 10
          },
          "data-clarity-unmask": "True",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            style: {
              textTransform: "uppercase",
              fontSize: 13.5,
              color: "#2d2d32",
              fontWeight: 500
            },
            "data-clarity-unmask": "True",
            children: ["Legal Consultation @", " "]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            style: {
              display: "inline-block",
              textTransform: "uppercase",
              fontSize: 14,
              color: "#2d2d32",
              fontWeight: 700
            },
            "data-clarity-unmask": "True",
            children: [" ", geolocation === "in" ? "₹750" : "$45"]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            style: {
              fontSize: 13.5,
              color: "#2d2d32",
              fontWeight: 500
            },
            "data-clarity-unmask": "True",
            children: [" ", "for 30 min"]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "col-4",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FooterButton, {
            onClick: purchaseTalktime,
            children: "Consult Now"
          })
        })]
      })
    })
  });
};

/* harmony default export */ var components_StickyFooterCityLawyers = (StickyFooterCityLawyers);

/***/ }),

/***/ 9556:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useResponsiveDevice; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_ezylegal_apps_ezylegal_apps_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7113);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _constants_deviceTypes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1821);



function useResponsiveDevice() {
  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState(_constants_deviceTypes__WEBPACK_IMPORTED_MODULE_1__/* .DeviceTypes.DESKTOP */ .h.DESKTOP),
      _React$useState2 = (0,_home_runner_work_ezylegal_apps_ezylegal_apps_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_React$useState, 2),
      device = _React$useState2[0],
      setDevice = _React$useState2[1];

  react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect(function () {
    var handleResize = function handleResize() {
      setDevice(window.innerWidth < 768 ? _constants_deviceTypes__WEBPACK_IMPORTED_MODULE_1__/* .DeviceTypes.MOBILE */ .h.MOBILE : _constants_deviceTypes__WEBPACK_IMPORTED_MODULE_1__/* .DeviceTypes.DESKTOP */ .h.DESKTOP);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return {
    isMobile: device === _constants_deviceTypes__WEBPACK_IMPORTED_MODULE_1__/* .DeviceTypes.MOBILE */ .h.MOBILE,
    isDesktop: device === _constants_deviceTypes__WEBPACK_IMPORTED_MODULE_1__/* .DeviceTypes.DESKTOP */ .h.DESKTOP
  };
}

/***/ }),

/***/ 1821:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ DeviceTypes; }
/* harmony export */ });
var DeviceTypes;

(function (DeviceTypes) {
  DeviceTypes[DeviceTypes["DESKTOP"] = 0] = "DESKTOP";
  DeviceTypes[DeviceTypes["MOBILE"] = 1] = "MOBILE";
})(DeviceTypes || (DeviceTypes = {}));

/***/ }),

/***/ 5691:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ap": function() { return /* binding */ OTP_VERIFY_QUERY; },
/* harmony export */   "Go": function() { return /* binding */ LOGIN_QUERY; },
/* harmony export */   "KQ": function() { return /* binding */ CREATE_USER_QUERY; },
/* harmony export */   "Xo": function() { return /* binding */ SUBSCRIBE_TO_NEWSLETER; }
/* harmony export */ });
/* unused harmony exports GET_USER_ORGANIZATION, Update_USER_Mutation, GET_USER_AVAILABLE_BALANCE, GET_USER_ORGANIZATION_DATA, GET_USER */
var CREATE_USER_QUERY = "mutation createUser(\n  $email: String!,\n  $name: String!,\n  $mobile: Float!,\n  $country: String\n  $countryCode: Int!\n  $type: UserType!\n  $concerned_area: String\n  $device: String\n  $device_type: String\n  $page_url: String\n  $user_agent: String\n  $user_ip_address: String\n  $source: String\n  ) {\n    createUser(createUserInput: {\n      email: $email,\n      name: $name,\n      mobile: $mobile,\n      country: $country\n      country_code: $countryCode\n      user_type: $type\n      concerned_area: $concerned_area\n      device: $device\n      device_type: $device_type\n      page_url: $page_url,\n      user_agent: $user_agent,\n      user_ip_address: $user_ip_address,\n      source: $source,\n    }) {\n    _id\n    address\n    city\n    company\n    gst\n    country\n    country_code\n    email\n    emailList\n    mobile\n    name\n    pincode\n    professional_details{\n      bar_council_id_no\n      bar_council_id_image\n      degree\n      passing_year\n      practice_courts{\n        state\n        city\n        court\n      }\n      practice_year\n      specialization\n      language\n      university\n    }\n    profile_image\n    state\n    status\n    user_type\n    jwt_token\n    status\n    gender\n    organization\n    b2b_user_type\n    }\n  }";
var GET_USER_ORGANIZATION = "\nquery getOrganization($slug: String!) {\n  getOrganization(slug: $slug) {\n    _id\n    address\n    affiliation_code\n    affiliation_institute\n    city\n    mobile\n    name\n    slug\n    state\n    tax\n    admin{\n      _id\n    }\n\n  }\n}\n";
var Update_USER_Mutation = "\n  mutation Update_User(\n    $_id: String!\n    $city: String\n    $country_code: Int!\n    $email: String!\n    $mobile: Float!\n    $name: String!\n    $state: String\n    $company: String!\n    $gst: String!\n  ){\n    updateUser(updateUserInput:{\n      _id:$_id\n      city:$city\n      country_code: $country_code\n      email:$email\n      mobile:$mobile\n      name:$name\n      state:$state\n      company:$company\n      gst:$gst\n    }){\n    _id\n    address\n    city\n    gst\n    company\n    country_code\n    email\n    emailList\n    mobile\n    name\n    pincode\n    professional_details{\n      bar_council_id_no\n      bar_council_id_image\n      degree\n      passing_year\n      practice_courts{\n        state\n        city\n        court\n      }\n      practice_year\n      specialization\n      university\n    }\n    profile_image\n    state\n    status\n    user_type\n    jwt_token\n    status\n    gender\n    }\n  }\n  ";
var LOGIN_QUERY = "mutation loginUser($mobile: Float!, $countryCode: Int!) {\n  loginUser(loginUserInput: {\n    country_code: $countryCode\n    mobile: $mobile\n  }) {\n    _id\n    name\n    country_code\n    company\n    email\n    mobile\n    status\n    b2b_user_type\n    organization\n  }\n}";
var OTP_VERIFY_QUERY = "mutation verifyOtp($mobile: Float!, $otp: Float!, $country_code: Float!) {\n  verifyOtp(verifyOtpInput: {\n    mobile: $mobile\n    otp: $otp,\n    country_code: $country_code\n  }) {\n    _id\n    city\n    company\n    gst\n    country_code\n    email\n    emailList\n    mobile\n    name\n    pincode\n    professional_details{\n      bar_council_id_no\n      bar_council_id_image\n      degree\n      passing_year\n      practice_courts{\n        state\n        city\n        court\n      }\n      practice_year\n      specialization\n      language\n      university\n    }\n    profile_image\n    state\n    status\n    user_type\n    jwt_token\n    is_online\n    is_verified\n    status\n    gender\n    b2b_user_type\n    organization\n  }\n}";
var SUBSCRIBE_TO_NEWSLETER = "\nmutation subscribeToNewsletter($email: String!){\n  subscribeNewLetter(newsLetterInput: {\n    email: $email\n  }){\n    _id,\n    email\n  }\n}\n";
var GET_USER_AVAILABLE_BALANCE = "\nquery getUser($userId: String!){\n  getUser(_id: $userId){\n    _id\n    available_calling_balance\n    available_calling_balance_business\n    available_calling_balance_document\n  }\n}\n";
var GET_USER_ORGANIZATION_DATA = "\nquery getUser($userId: String!){\n  getUser(_id: $userId){\n    _id\n    city\n    company\n    gst\n    country_code\n    email\n    emailList\n    mobile\n    name\n    pincode\n    professional_details{\n      bar_council_id_no\n      bar_council_id_image\n      degree\n      passing_year\n      practice_courts{\n        state\n        city\n        court\n      }\n      practice_year\n      specialization\n      language\n      university\n    }\n    profile_image\n    state\n    status\n    user_type\n    jwt_token\n    is_online\n    is_verified\n    status\n    gender\n    b2b_user_type\n    organization\n  }\n}\n";
var GET_USER = "\nquery getUser($userId: String!) {\n  getUser(_id: $userId) {\n    _id\n    city\n    company\n    gst\n    country_code\n    email\n    emailList\n    mobile\n    name\n    pincode\n    professional_details{\n      bar_council_id_no\n      bar_council_id_image\n      degree\n      passing_year\n      practice_courts{\n        state\n        city\n        court\n      }\n      practice_year\n      specialization\n      language\n      university\n    }\n    profile_image\n    state\n    status\n    user_type\n    jwt_token\n    is_online\n    is_verified\n    status\n    gender\n    b2b_user_type\n    organization\n    available_calling_balance\n    available_calling_balance_business\n    available_calling_balance_document\n  }\n}\n";

/***/ }),

/***/ 6486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "pH": function() { return /* binding */ loginUser; },
  "yM": function() { return /* binding */ setLoggedInUser; },
  "y1": function() { return /* binding */ signUp; },
  "Mu": function() { return /* binding */ verifyOtp; }
});

// UNUSED EXPORTS: Update_User_Profile, getCurrentUser, setUserData, verifyOrganizationApproval

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(8526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./api/backendApi.ts
var api_backendApi = __webpack_require__(5484);
// EXTERNAL MODULE: ./constants/queries/user.tsx
var queries_user = __webpack_require__(5691);
// EXTERNAL MODULE: ./utils/toasts.ts
var toasts = __webpack_require__(3200);
// EXTERNAL MODULE: ./redux/loggedInUser/loggedInUser.types.ts
var loggedInUser_types = __webpack_require__(7578);
// EXTERNAL MODULE: ./redux/loader/loader.types.ts
var loader_types = __webpack_require__(8379);
;// CONCATENATED MODULE: ./redux/loader/loader.actions.ts

var loader_actions_setLoadingState = function setLoadingState(isLoading) {
  return function (dispatch) {
    dispatch({
      type: loader_types/* SET_LOADING_STATE */.R,
      payload: isLoading
    });
  };
};
// EXTERNAL MODULE: ./redux/newCheckout/newCheckout.actions.ts
var newCheckout_actions = __webpack_require__(5000);
;// CONCATENATED MODULE: ./redux/loggedInUser/loggedInUser.actions.ts








var setLoggedInUser = function setLoggedInUser(data) {
  return function (dispatch) {
    dispatch({
      type: loggedInUser_types/* SET_LOGGEDIN_USER */.fw,
      payload: data
    });

    if (data && data._id) {
      dispatch((0,newCheckout_actions/* updateNewCheckoutState */.C$)({
        newCheckoutFlow: false
      }));
    } else {
      dispatch((0,newCheckout_actions/* updateNewCheckoutState */.C$)({
        newCheckoutFlow: true
      }));
    }
  };
};
var signUp = function signUp(user, cb) {
  var showErrorToast = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(dispatch) {
      var _userRes$data$errors, userRes;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return api_backendApi/* default.post */.Z.post("/", {
                query: queries_user/* CREATE_USER_QUERY */.KQ,
                variables: {
                  email: user.email.toLowerCase(),
                  name: user.name,
                  mobile: parseFloat(user.mobile),
                  countryCode: parseInt(user.countryCode),
                  type: user.type,
                  device: user.device,
                  device_type: user.device_type,
                  page_url: user.page_url,
                  user_agent: user.user_agent,
                  user_ip_address: user.user_ip_address,
                  source: user.source,
                  country: user.country,
                  // company: user.'company,'
                  gst: user.gst
                }
              });

            case 3:
              userRes = _context.sent;

              if (!((_userRes$data$errors = userRes.data.errors) !== null && _userRes$data$errors !== void 0 && _userRes$data$errors.length)) {
                _context.next = 6;
                break;
              }

              throw new Error(userRes.data.errors[0].message);

            case 6:
              localStorage.setItem("ezyLegalUserData", JSON.stringify(userRes.data.data.createUser));
              dispatch(setLoggedInUser(userRes.data.data.createUser));
              cb();
              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](0);
              if (showErrorToast) if (_context.t0 instanceof Error) (0,toasts/* errorToast */.Jc)(_context.t0.message);else cb();

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 11]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
var Update_User_Profile = function Update_User_Profile(user, logingUserData, cb) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch) {
      var _userRes$data$errors2, userRes;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return backendApi.post("/", {
                query: Update_USER_Mutation,
                variables: {
                  _id: logingUserData._id,
                  city: user.city || "",
                  company: user.companyName || "",
                  country_code: logingUserData.country_code || "",
                  email: user.email.toLowerCase(),
                  gst: user.gst || "",
                  mobile: parseFloat(user.number),
                  name: user.name,
                  state: user.state
                }
              });

            case 3:
              userRes = _context2.sent;

              if (!((_userRes$data$errors2 = userRes.data.errors) !== null && _userRes$data$errors2 !== void 0 && _userRes$data$errors2.length)) {
                _context2.next = 6;
                break;
              }

              throw new Error(userRes.data.errors[0].message);

            case 6:
              localStorage.setItem("ezyLegalUserData", JSON.stringify(userRes.data.data.updateUser));
              dispatch(setLoggedInUser(userRes.data.data.updateUser));
              cb();
              _context2.next = 15;
              break;

            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](0);
              dispatch(setLoadingState(false));
              if (_context2.t0 instanceof Error) errorToast(_context2.t0.message);

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 11]]);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var loginUser = function loginUser(data, cb) {
  return /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(dispatch) {
      var _userRes$data$errors3, userRes;

      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return api_backendApi/* default.post */.Z.post("/", {
                query: queries_user/* LOGIN_QUERY */.Go,
                variables: {
                  mobile: parseFloat(data.mobile),
                  countryCode: parseInt(data.countryCode)
                }
              });

            case 3:
              userRes = _context3.sent;

              if (!((_userRes$data$errors3 = userRes.data.errors) !== null && _userRes$data$errors3 !== void 0 && _userRes$data$errors3.length)) {
                _context3.next = 6;
                break;
              }

              throw new Error(userRes.data.errors[0].message);

            case 6:
              cb();
              _context3.next = 12;
              break;

            case 9:
              _context3.prev = 9;
              _context3.t0 = _context3["catch"](0);
              if (_context3.t0 instanceof Error) (0,toasts/* errorToast */.Jc)(_context3.t0.message);

            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 9]]);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var verifyOrganizationApproval = function verifyOrganizationApproval(data) {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dispatch) {
      var userRes;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return backendApi.post("/", {
                query: GET_USER_ORGANIZATION_DATA,
                variables: {
                  userId: data.userId
                }
              });

            case 3:
              userRes = _context4.sent;

              if (userRes.data.data.getUser) {
                JSON.stringify(userRes.data.data.getUser), dispatch(setLoggedInUser(userRes.data.data.getUser));
              }

              _context4.next = 11;
              break;

            case 7:
              _context4.prev = 7;
              _context4.t0 = _context4["catch"](0);
              dispatch(setLoadingState(false));
              if (_context4.t0 instanceof Error) errorToast(_context4.t0.message);

            case 11:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 7]]);
    }));

    return function (_x4) {
      return _ref4.apply(this, arguments);
    };
  }();
};
var verifyOtp = function verifyOtp(data, cb) {
  return /*#__PURE__*/function () {
    var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5(dispatch) {
      var _userRes$data$errors4, userRes;

      return regenerator_default().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return api_backendApi/* default.post */.Z.post("/", {
                query: queries_user/* OTP_VERIFY_QUERY */.Ap,
                variables: {
                  mobile: parseFloat(data.mobile),
                  country_code: parseFloat(data.countryCode),
                  otp: parseFloat(data.otp)
                }
              });

            case 3:
              userRes = _context5.sent;

              if (!((_userRes$data$errors4 = userRes.data.errors) !== null && _userRes$data$errors4 !== void 0 && _userRes$data$errors4.length)) {
                _context5.next = 6;
                break;
              }

              throw new Error(userRes.data.errors[0].message);

            case 6:
              localStorage.setItem("ezyLegalUserData", JSON.stringify(userRes.data.data.verifyOtp));
              dispatch(setLoggedInUser(userRes.data.data.verifyOtp));
              cb();
              _context5.next = 15;
              break;

            case 11:
              _context5.prev = 11;
              _context5.t0 = _context5["catch"](0);
              dispatch(loader_actions_setLoadingState(false));
              if (_context5.t0 instanceof Error) (0,toasts/* errorToast */.Jc)(_context5.t0.message);

            case 15:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[0, 11]]);
    }));

    return function (_x5) {
      return _ref5.apply(this, arguments);
    };
  }();
};

/**
 * Gets the current user's information. This information supplements the logged in user info when needed
 * on demand.
 */
var getCurrentUser = function getCurrentUser(data) {
  return /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(dispatch) {
      var _userRes$data$errors5, userRes;

      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              _context6.next = 3;
              return backendApi.post("/", {
                query: GET_USER_AVAILABLE_BALANCE,
                variables: data
              });

            case 3:
              userRes = _context6.sent;

              if (!((_userRes$data$errors5 = userRes.data.errors) !== null && _userRes$data$errors5 !== void 0 && _userRes$data$errors5.length)) {
                _context6.next = 6;
                break;
              }

              throw new Error(userRes.data.errors[0].message);

            case 6:
              dispatch({
                type: SET_CURRENT_USER,
                payload: userRes.data.data.getUser
              });
              _context6.next = 12;
              break;

            case 9:
              _context6.prev = 9;
              _context6.t0 = _context6["catch"](0);

              if (_context6.t0 instanceof Error) {
                errorToast(_context6.t0.message);
              }

            case 12:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[0, 9]]);
    }));

    return function (_x6) {
      return _ref6.apply(this, arguments);
    };
  }();
};
var setUserData = function setUserData(data) {
  return function (dispatch) {
    dispatch({
      type: SET_CURRENT_USER,
      payload: data
    });
  };
};

/***/ }),

/***/ 5000:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C$": function() { return /* binding */ updateNewCheckoutState; }
/* harmony export */ });
/* unused harmony exports setLoggedInUser, updateAndCheckoutNewUser, checkoutNewUser, updateCheckoutUser */
/* harmony import */ var _home_runner_work_ezylegal_apps_ezylegal_apps_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8526);
/* harmony import */ var _home_runner_work_ezylegal_apps_ezylegal_apps_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_ezylegal_apps_ezylegal_apps_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _newCheckout_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9176);
/* harmony import */ var _api_backendApi__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5484);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var updateNewCheckoutState = function updateNewCheckoutState(data) {
  return function (dispatch) {
    dispatch({
      type: _newCheckout_types__WEBPACK_IMPORTED_MODULE_2__/* .UPDATE_NEWCHECKOUT_STATE */ .a,
      payload: data
    });
  };
};
var setLoggedInUser = function setLoggedInUser(data) {
  return function (dispatch) {
    dispatch({
      type: SET_LOGGEDIN_USER,
      payload: data
    });

    if (data && data._id) {
      dispatch(updateNewCheckoutState({
        newCheckoutFlow: false
      }));
    } else {
      dispatch(updateNewCheckoutState({
        newCheckoutFlow: true
      }));
    }
  };
};
var updateAndCheckoutNewUser = function updateAndCheckoutNewUser(user, userData, cart, tax, cb) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var _userRes$data$errors, userRes;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return backendApi.post("/", {
                query: Update_USER_Mutation,
                variables: {
                  _id: userData._id,
                  country: user.country,
                  country_code: user.countryCode ? parseInt(user.countryCode) : userData.country_code,
                  email: user.email.toLowerCase(),
                  mobile: parseFloat(user.mobile),
                  name: user.name,
                  type: user.type,
                  gst: userData.gst ? userData.gst : "",
                  company: userData.companyName ? userData.companyName : "",
                  city: userData !== null && userData !== void 0 && userData.city ? userData === null || userData === void 0 ? void 0 : userData.city : "",
                  state: userData.state ? userData.state : ""
                }
              });

            case 3:
              userRes = _context.sent;

              if (!((_userRes$data$errors = userRes.data.errors) !== null && _userRes$data$errors !== void 0 && _userRes$data$errors.length)) {
                _context.next = 6;
                break;
              }

              throw new Error(userRes.data.errors[0].message);

            case 6:
              dispatch(updateNewCheckoutState({
                newUserData: _objectSpread({}, userRes.data.data.updateUser)
              }));
              cb();
              _context.next = 14;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](0);
              dispatch(setLoadingState(false));
              errorToast(_context.t0.message);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 10]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
var checkoutNewUser = function checkoutNewUser(user, cart, tax, cb) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch) {
      var _userData$data$errors, obj, userData;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              obj = cart.items[0].concernedArea && {
                concerned_area: cart.items[0].concernedArea.toLowerCase()
              };
              _context2.next = 4;
              return backendApi.post("/", {
                query: CREATE_USER_QUERY,
                variables: _objectSpread({
                  email: user.email.toLowerCase(),
                  name: user.name,
                  mobile: parseFloat(user.mobile),
                  country: user.country,
                  countryCode: parseInt(user.countryCode),
                  type: user.type,
                  state: user.state,
                  device: user.device,
                  device_type: user.device_type,
                  page_url: user.page_url,
                  user_agent: user.user_agent,
                  user_ip_address: user.user_ip_address,
                  source: user.source
                }, obj)
              });

            case 4:
              userData = _context2.sent;

              if (!((_userData$data$errors = userData.data.errors) !== null && _userData$data$errors !== void 0 && _userData$data$errors.length)) {
                _context2.next = 7;
                break;
              }

              throw new Error(userData.data.errors[0].message);

            case 7:
              // dispatch(
              //   updateNewCheckoutState({
              //     newUserData: { ...userData.data.data.createUser },
              //   }),
              // );
              localStorage.setItem("ezyLegalUserData", JSON.stringify(userData.data.data.createUser));
              dispatch(setLoggedInUser(userData.data.data.createUser));
              if (cb) cb();
              _context2.next = 16;
              break;

            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2["catch"](0);
              errorToast(_context2.t0.message);
              dispatch(setLoadingState(false));

            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 12]]);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var updateCheckoutUser = function updateCheckoutUser(user, userData, cb) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dispatch) {
      var _userRes$data$errors2, userRes;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return backendApi.post("/", {
                query: Update_USER_Mutation,
                variables: {
                  _id: userData._id,
                  city: user === null || user === void 0 ? void 0 : user.city,
                  company: (user === null || user === void 0 ? void 0 : user.companyName) !== null ? user === null || user === void 0 ? void 0 : user.companyName : "",
                  country_code: userData.country_code,
                  email: user === null || user === void 0 ? void 0 : user.email.toLowerCase(),
                  gst: (user === null || user === void 0 ? void 0 : user.gst) !== null ? user.gst : "",
                  mobile: parseFloat(user === null || user === void 0 ? void 0 : user.number),
                  name: user === null || user === void 0 ? void 0 : user.name,
                  state: user === null || user === void 0 ? void 0 : user.state
                }
              });

            case 3:
              userRes = _context3.sent;

              if (!((_userRes$data$errors2 = userRes.data.errors) !== null && _userRes$data$errors2 !== void 0 && _userRes$data$errors2.length)) {
                _context3.next = 6;
                break;
              }

              throw new Error(userRes.data.errors[0].message);

            case 6:
              dispatch(updateNewCheckoutState({
                newUserData: _objectSpread({}, userRes.data.data.updateUser)
              }));
              cb();
              _context3.next = 14;
              break;

            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3["catch"](0);
              dispatch(setLoadingState(false));
              errorToast(_context3.t0.message);

            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 10]]);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};

/***/ }),

/***/ 3223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5505);

var HeadingText2 = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
  displayName: "HeadingText2",
  componentId: "sc-ahicii-0"
})(["color:", ";font-size:", ";font-family:", ";font-weight:", ";line-height:1.5em;margin-bottom:8px;", " ", " ", " ", ""], function (_ref) {
  var theme = _ref.theme,
      color = _ref.color;
  return theme.textColors[color || '#091E42'];
}, function (_ref2) {
  var theme = _ref2.theme,
      fontSize = _ref2.fontSize;
  return theme.fontSize[fontSize || 'md'];
}, function (_ref3) {
  var theme = _ref3.theme,
      fontFamily = _ref3.fontFamily;
  return theme.fontFamily[fontFamily || 'manrope'];
}, function (_ref4) {
  var theme = _ref4.theme,
      weight = _ref4.weight;
  return theme.fontWeight[weight || 'normal'];
}, function (props) {
  return props.inline && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["display:inline-block;"]);
}, function (props) {
  return props.block && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["display:block;"]);
}, function (props) {
  return props.center && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["text-align:center;"]);
}, function (props) {
  return props.justify && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["text-align:justify;"]);
});
/* harmony default export */ __webpack_exports__["Z"] = (HeadingText2);

/***/ }),

/***/ 984:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5505);

var Spacer = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "Spacer",
  componentId: "sc-1d461xh-0"
})(["display:block;", " ", ""], function (props) {
  return props.direction === 'vertical' && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["height:", "px;"], props.size);
}, function (props) {
  return props.direction === 'horizontal' && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["width:", "px;display:inline-block;"], props.size);
});
/* harmony default export */ __webpack_exports__["Z"] = (Spacer);

/***/ }),

/***/ 661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5505);

var Text = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "Text",
  componentId: "sc-1v4ef3e-0"
})(["color:", ";font-size:", ";font-family:", ";font-weight:", ";line-height:1.5em;margin-bottom:8px;", " ", " ", " ", " ", ""], function (_ref) {
  var theme = _ref.theme,
      color = _ref.color;
  return theme.textColors[color || "#091E42"];
}, function (_ref2) {
  var theme = _ref2.theme,
      fontSize = _ref2.fontSize;
  return theme.fontSize[fontSize || "md"];
}, function (_ref3) {
  var theme = _ref3.theme,
      fontFamily = _ref3.fontFamily;
  return theme.fontFamily[fontFamily || "manrope"];
}, function (_ref4) {
  var theme = _ref4.theme,
      weight = _ref4.weight;
  return theme.fontWeight[weight || "normal"];
}, function (props) {
  return props.inline && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["display:inline-block;"]);
}, function (props) {
  return props.block && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["display:block;"]);
}, function (props) {
  return props.center && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["text-align:center;"]);
}, function (props) {
  return props.justify && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["text-align:justify;"]);
}, function (props) {
  return props.hover && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["&:hover{text-decoration:", ";}"], props.hover);
});
/* harmony default export */ __webpack_exports__["Z"] = (Text);

/***/ }),

/***/ 6902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "VQ": function() { return /* binding */ getPageURL; },
/* harmony export */   "ij": function() { return /* binding */ getUserAgent; }
/* harmony export */ });
/* unused harmony exports getIpAddress, getDeviceDetails */
/* harmony import */ var _home_runner_work_ezylegal_apps_ezylegal_apps_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8526);
/* harmony import */ var _home_runner_work_ezylegal_apps_ezylegal_apps_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_ezylegal_apps_ezylegal_apps_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9644);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);



var getIpAddress = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _yield$axios$get, data;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return axios.get('http://ip-api.com/json');

          case 3:
            _yield$axios$get = _context.sent;
            data = _yield$axios$get.data;
            return _context.abrupt("return", data);

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            console.error(_context.t0.message);
            return _context.abrupt("return", {});

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  }));

  return function getIpAddress() {
    return _ref.apply(this, arguments);
  };
}()));
var getPageURL = function getPageURL() {
  return window.location.href;
};
var getDeviceDetails = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var type, options, _yield$axios$request, data;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            type = 'GET';
            options = {
              method: type,
              url: 'https://userstack.com/ua_api.php',
              params: {
                ua: navigator.userAgent
              }
            };
            _context2.prev = 2;
            _context2.next = 5;
            return axios.request(options);

          case 5:
            _yield$axios$request = _context2.sent;
            data = _yield$axios$request.data;
            return _context2.abrupt("return", data);

          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](2);
            console.error(_context2.t0.message);
            return _context2.abrupt("return", {});

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[2, 10]]);
  }));

  return function getDeviceDetails() {
    return _ref2.apply(this, arguments);
  };
}()));
var getUserAgent = function getUserAgent() {
  return navigator.userAgent;
};

/***/ }),

/***/ 3152:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var selectCountry = function selectCountry(country) {
  switch (country) {
    case 'US':
      return '1';
      break;

    case 'CA':
      return '1';
      break;

    case 'IN':
      return '91';
      break;

    case 'GB':
      return '44';
      break;

    case 'ZA':
      return '27';
      break;

    case 'AU':
      return '61';
      break;

    case 'SG':
      return '65';
      break;

    case 'MY':
      return '60';
      break;

    case 'AE':
      return '971';
      break;

    case 'SA':
      return '966';
      break;

    default:
      return '91';
      break;
  }
};

/* harmony default export */ __webpack_exports__["Z"] = (selectCountry);

/***/ }),

/***/ 3200:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jc": function() { return /* binding */ errorToast; },
/* harmony export */   "Qm": function() { return /* binding */ successToast; }
/* harmony export */ });
/* unused harmony export infoToast */
/* harmony import */ var react_toastify__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6052);

var errorToast = function errorToast(message) {
  react_toastify__WEBPACK_IMPORTED_MODULE_0__/* .toast.error */ .Am.error(message);
};
var successToast = function successToast(message) {
  react_toastify__WEBPACK_IMPORTED_MODULE_0__/* .toast.success */ .Am.success(message);
};
var infoToast = function infoToast(message) {
  toast.info(message);
};

/***/ })

}]);